import React, { Component } from "react";
import {
  Alert,
  Collapse,
  Divider,
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Checkbox,
  Space,
  Empty,
  Select,
  Tooltip,
  Input,
  Radio,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  DatePickerItem,
  InputItem,
  SelectItem,
  ModalItem,
  ButtonItem,
  round2Decimals,
  cuentaMask,
  NotificacionPolizas,
  ErrorItem,
  MensajeError,
  SegmentedItem,
} from "../../../../../Components/Items";
import DynamicCardForm from "../../../../../Components/DynamicCardForm";
import TabbedDynamicTable from "../../../../../Components/TabbedDynamicTable";
import AgregarCuentaContable from "../../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { DndContext, DragOverlay, PointerSensor } from "@dnd-kit/core";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as XLSX from "xlsx";
import { FileExcelOutlined, SaveOutlined, UploadOutlined, ExclamationCircleFilled, CheckCircleFilled, QuestionCircleOutlined, PlusOutlined, VerticalAlignTopOutlined, RightOutlined } from "@ant-design/icons";
import ModalPdfPoliza from "../../../../../Components/ModalPdfPoliza";
import BotonesOrigenCargoAbono from "../../../../../Components/BotonesOrigenCargoAbono";
import {
  extraerLineasDePdf,
  extraerMovimientosBanco,
  empatarMovimientos,
  tomarPdfPendiente,
  claveMovimientoPdf,
  mensajePdfDeOtroBanco,
  guardarRelacionesManuales,
  leerRelacionesManuales,
  borrarRelacionesManuales,
} from "./extraerDatosBancoPdf";
import { listaPlantillas } from "./plantillasBancos";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { Option } = Select;

const SENSORES_DND = [
  { sensor: PointerSensor, options: { activationConstraint: { distance: 8 } } },
];
const cachePdfConciliacion = new Map();
// Alto de la barra fija con el encabezado de la sección en curso (= encabezado del Collapse).
const ALTO_BARRA_SECCION = 46;


function TarjetaDnD({ id, children, incompatible }) {
  const drag = useDraggable({ id });
  const drop = useDroppable({ id, disabled: !!incompatible });
  const setRefs = (node) => {
    drag.setNodeRef(node);
    drop.setNodeRef(node);
  };
  // Clases para el azul tenue (Styles.css): hover, card que se arrastra y card destino.
  const clases = [
    "tarjeta-dnd",
    drag.isDragging ? "tarjeta-dnd--arrastrando" : "",
    drop.isOver ? "tarjeta-dnd--destino" : "",
  ].join(" ").trim();
  return (
    <div
      ref={setRefs}
      className={clases}
      {...drag.listeners}
      {...drag.attributes}
      style={{
        opacity: drag.isDragging ? 0.35 : incompatible ? 0.35 : 1,
        marginBottom: 4,
        borderRadius: 6,
        outline: drop.isOver ? "2px dashed #00BFD6" : "2px dashed transparent",
        outlineOffset: 2,
        filter: incompatible ? "grayscale(1)" : "none",
        transition: "outline-color 0.15s ease, opacity 0.15s ease, filter 0.15s ease",
      }}
    >
      {children}
    </div>
  );
}

class Conciliacion extends Component {
  formRef = React.createRef();
  formRefDatosConciliacion = React.createRef();
  formRefAjuste = React.createRef();
  pdfInputRef = React.createRef();
  // Inicio de los tabs (pestañas + resumen + índice): destino de la flecha de cada sección.
  inicioRef = React.createRef();
  // Anclas de las secciones del resultado del PDF (índice de navegación).
  seccionesRef = {
    sinConciliar: React.createRef(),
    conciliadosSistema: React.createRef(),
    conciliadosManual: React.createRef(),
    yaConciliados: React.createRef(),
    fueraRango: React.createRef(),
    devoluciones: React.createRef(),
  };
  titulosSeccion = {};
  rafSeccionFija = null;
  state = {
    loading: false,
    cargosAbonos: [],
    saldoInicial: 0,
    saldoFinal: 0,
    totalCargos: 0,
    totalAbonos: 0,
    saldosCongelados: false,
    fechaInicial: null, // periodo de la conciliación: delimita qué movimientos del PDF entran al proceso principal
    fechaFinal: null,
    pdfResultado: null,
    pdfLineas: null,
    pdfPlantillaId: null, 
    pdfAutodetectada: false,
    claveSatCuenta: null, 
    bancoSatNombre: null, 
    empatesManual: [], 
    gruposManual: [],
    modalEmpate: null,
    modalEmpateVisible: false,
    seleccionGrupo: [], // movimientos marcados en la lista
    busquedaGrupo: "",
    autosRotos: [], // _id de cargosAbonos cuyo empate automático se rompió por D&D
    // Devoluciones del banco (retiro + su devolución) que el usuario decidió cancelar
    // entre sí (claveMovimientoPdf de la devolución). Por defecto se toman por separado.
    reversosCancelados: [],
    modalCentavos: false, // modal de parejas con diferencia de centavos (se abre al cargar el PDF)
    sugerenciasCentavos: [], // [{ ca, mov, dif, difDias }] detectadas al abrir el modal
    seleccionCentavos: [], // sugerencias marcadas por el usuario (inician desmarcadas)
    modalPosterior: null, // mov del PDF (posterior a la fecha final) que se está conciliando con el selector
    seleccionPosterior: null, // cargoAbono del sistema elegido en ese selector
    busquedaPosterior: "",
    modalMasivo: null, // "conciliar" | "quitar": confirmación del check global de la columna Conciliado
    aplicandoMasivo: false,
    dragId: null, // id de la card que se está arrastrando (para el overlay)
    // Secciones desplegadas del resultado del PDF: las pendientes inician abiertas;
    // "ya conciliados" y "fuera del rango" inician cerradas.
    seccionesAbiertas: ["sinConciliar", "conciliadosSistema", "conciliadosManual"],
    seccionIndice: null, // opción marcada en el índice de secciones (la última a la que se fue)
    modalHistorialPdf: null, // { pdfCargado, manuales }: PDF re-subido con avance guardado, esperando "continuar" o "empezar de 0"
    tabInicialPdf: false, // abrir directo en el tab "Cargar PDF" (creada desde PDF)
    ventanaDias: 0, // brecha de días permitida al empatar mov. del PDF con el sistema (0 = misma fecha exacta)
    modalPdfPoliza: false,
    polizaIdPdf: null,
    cuentaAjusteConciliacionId: undefined, // cuenta de ajuste configurada en la empresa (puede venir vacía)
    ajusteMaxConciliacion: undefined, // tope configurado en la empresa para el ajuste automático (undefined = usar 0.5)
    monedaBanco: null, // moneda de la cuenta bancaria de esta conciliacion ({ _id, abreviacion })
    todasProyectos: null,
    objetoProyectos: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    modalAjuste: false,
    guardandoAjuste: false,
    tcAjuste: null, // tipo de cambio capturado en el modal de ajuste (para mostrar el equivalente en pesos)
    modalAgregarCuentaContable: false,
    seccionFija: null, // { clave, top, left, width }: sección del PDF cuyo encabezado se fija arriba
  };
  componentWillUnmount() {
    // Por si se sale de la pantalla a medio arrastre.
    this.marcarArrastre(false);
    window.removeEventListener("scroll", this.medirSeccionFija);
    window.removeEventListener("resize", this.medirSeccionFija);
    if (this.rafSeccionFija) cancelAnimationFrame(this.rafSeccionFija);
  }
  componentDidMount() {
    this.consultarTodo();
    this.consultarProyectos();
    this.consultarCuentasContables();
    window.addEventListener("scroll", this.medirSeccionFija, { passive: true });
    window.addEventListener("resize", this.medirSeccionFija);
  }

  // Encabezado fijo de las secciones del PDF: al bajar por una sección abierta, en
  // cuanto su encabezado pasa por debajo del header de la app aparece una barra fija
  // con su título; al terminar la sección la barra pasa a la siguiente (o se oculta).
  // Es una barra propia con position: fixed (no sticky sobre el header de antd), así
  // no depende de los overflow de los contenedores ni deforma el desplegable.
  medirSeccionFija = () => {
    if (this.rafSeccionFija) return;
    this.rafSeccionFija = requestAnimationFrame(() => {
      this.rafSeccionFija = null;
      const tope = document.getElementById("header-fixed")?.getBoundingClientRect().bottom || 64;
      let fija = null;
      for (const clave of this.state.seccionesAbiertas) {
        const nodo = this.seccionesRef[clave]?.current;
        if (!nodo || nodo.offsetParent === null) continue; // sin montar u oculta (otra pestaña)
        const r = nodo.getBoundingClientRect();
        // Su encabezado ya quedó bajo el header y aún le queda lista visible debajo.
        if (r.top < tope && r.bottom > tope + ALTO_BARRA_SECCION) {
          fija = { clave, top: tope, left: r.left, width: r.width };
          break;
        }
      }
      const prev = this.state.seccionFija;
      const igual =
        prev === fija ||
        (prev && fija && prev.clave === fija.clave && prev.top === fija.top &&
          prev.left === fija.left && prev.width === fija.width);
      if (!igual) this.setState({ seccionFija: fija });
    });
  };
  async consultarProyectos() {
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
  }
  async consultarCuentasContables() {
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasCuentaContable: res.data,
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
                ) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
  }
  componentDidUpdate(prevProps, prevState) {
    // Guarda la actividad del PDF en el cache de sesión cuando cambia, para
    // conservarla al navegar a otros módulos y volver sin re-subir el PDF.
    if (
      this.state.pdfResultado &&
      (prevState.pdfResultado !== this.state.pdfResultado ||
        prevState.empatesManual !== this.state.empatesManual ||
        prevState.gruposManual !== this.state.gruposManual ||
        prevState.autosRotos !== this.state.autosRotos ||
        prevState.reversosCancelados !== this.state.reversosCancelados)
    ) {
      cachePdfConciliacion.set(this.props.location.state.id, {
        pdfResultado: this.state.pdfResultado,
        empatesManual: this.state.empatesManual,
        gruposManual: this.state.gruposManual,
        autosRotos: this.state.autosRotos,
        reversosCancelados: this.state.reversosCancelados,
        pdfPlantillaId: this.state.pdfPlantillaId,
        pdfAutodetectada: this.state.pdfAutodetectada,
      });
      this.persistirRelacionesManuales();
    }
    // Al plegar/desplegar secciones o cambiar el resultado, la barra fija se re-mide
    // sin esperar al siguiente scroll.
    if (
      prevState.seccionesAbiertas !== this.state.seccionesAbiertas ||
      prevState.pdfResultado !== this.state.pdfResultado
    ) {
      this.medirSeccionFija();
    }
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await this.consultarDatos(true);
    await this.consultarBancoCuenta();
    const id = this.props.location.state.id;
    // Restaura la actividad del PDF si quedó en el cache de esta sesión.
    const cache = cachePdfConciliacion.get(id);
    if (cache && cache.pdfResultado) {
      this.setState({
        pdfResultado: cache.pdfResultado,
        empatesManual: cache.empatesManual || [],
        gruposManual: cache.gruposManual || [],
        autosRotos: cache.autosRotos || [],
        reversosCancelados: cache.reversosCancelados || [],
        pdfPlantillaId: cache.pdfPlantillaId || null,
        pdfAutodetectada: cache.pdfAutodetectada || false,
      });
    } else {
      const pendiente = tomarPdfPendiente(id);
      if (pendiente && pendiente.lineas) {
        try {
          const anioRef = moment(this.state.cargosAbonos[0]?.fechaRegistro || undefined).year();
          const { movimientos, plantilla, autodetectada, conflicto } = extraerMovimientosBanco(
            pendiente.lineas,
            anioRef,
            { claveSatCuenta: this.state.claveSatCuenta }
          );
          if (conflicto) {
            this.avisarPdfDeOtroBanco(conflicto);
          } else if (movimientos.length > 0) {
            const reversosCancelados = this.reversosCanceladosGuardados();
            const resultado = this.empatarPdf(movimientos, reversosCancelados);
            this.setState({
              pdfResultado: resultado,
              reversosCancelados,
              pdfLineas: pendiente.lineas,
              pdfPlantillaId: plantilla.id,
              pdfAutodetectada: autodetectada,
              tabInicialPdf: true,
              ...this.rehidratarRelacionesManuales(resultado),
            }, () => this.abrirModalCentavos());
          }
        } catch (err) {
          console.error("No se pudo cargar el PDF pendiente:", err);
        }
      }
    }
    this.setState({ loading: false });
  }

  async consultarBancoCuenta() {
    const bancoId = this.props.location.state.bancoId;
    if (!bancoId) return;
    try {
      const [resBanco, resBancosSat] = await Promise.all([
        axios.post(
          "bancos/datosBanco",
          { empresaId: this.props.empresaId, bancoId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "bancosSat/selectBancosSat",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
      ]);
      const bancoSatId = resBanco.data?.bancoSatId;
      const catalogo = Array.isArray(resBancosSat.data) ? resBancosSat.data : [];
      const bancoSat = catalogo.find((b) => String(b._id) === String(bancoSatId));
      if (bancoSat) {
        this.setState({
          claveSatCuenta: bancoSat.clave,
          bancoSatNombre: bancoSat.nombreCorto,
        });
      }
    } catch (err) {
      console.error("No se pudo consultar el banco de la cuenta:", err);
    }
  }

  avisarPdfDeOtroBanco(conflicto) {
    MensajeError(
      mensajePdfDeOtroBanco(conflicto, { bancoSatNombre: this.state.bancoSatNombre })
    );
  }

  rehidratarRelacionesManuales(pdfResultado) {
    const vacio = { empatesManual: [], gruposManual: [], autosRotos: [] };
    const guardado = leerRelacionesManuales(this.props.location.state.id);
    if (!guardado || !pdfResultado) return vacio;

    const casPorId = new Map(this.state.cargosAbonos.map((ca) => [String(ca._id), ca]));
    const poolPdf = new Map();
    const cancelados = pdfResultado.cancelados || [];
    this.candidatosPdf(pdfResultado).forEach((mov) => {
      if (cancelados.includes(mov)) return;
      const clave = claveMovimientoPdf(mov);
      if (!poolPdf.has(clave)) poolPdf.set(clave, []);
      poolPdf.get(clave).push(mov);
    });
    const tomarPdf = (clave) => {
      const lista = poolPdf.get(clave);
      return lista && lista.length ? lista.shift() : null;
    };
    const tomarSis = (id) => casPorId.get(String(id)) || null;

    const empatesManual = [];
    (guardado.empates || []).forEach((e) => {
      const ca = tomarSis(e.caId);
      const mov = tomarPdf(e.movKey);
      if (ca && mov) empatesManual.push({ ca, mov, dif: e.dif || 0 });
    });

    const gruposManual = [];
    (guardado.grupos || []).forEach((g) => {
      const principalObj =
        g.principalTipo === "sis" ? tomarSis(g.principalKey) : tomarPdf(g.principalKey);
      if (!principalObj) return;
      const tipoComp = g.principalTipo === "sis" ? "pdf" : "sis";
      const complementos = (g.complementos || [])
        .map((clave) => (tipoComp === "sis" ? tomarSis(clave) : tomarPdf(clave)))
        .filter(Boolean);
      if (!complementos.length) return;
      gruposManual.push({ principal: { tipo: g.principalTipo, obj: principalObj }, complementos });
    });

    const usadosSis = new Set();
    const usadosPdf = new Set();
    empatesManual.forEach((p) => {
      usadosSis.add(p.ca);
      usadosPdf.add(p.mov);
    });
    gruposManual.forEach((g) => {
      const setPrincipal = g.principal.tipo === "sis" ? usadosSis : usadosPdf;
      const setComplementos = g.principal.tipo === "sis" ? usadosPdf : usadosSis;
      setPrincipal.add(g.principal.obj);
      g.complementos.forEach((obj) => setComplementos.add(obj));
    });

    const autosRotos = [];
    (guardado.autosRotos || []).forEach((id) => {
      const ca = tomarSis(id);
      if (ca && !autosRotos.includes(ca._id)) autosRotos.push(ca._id);
    });
    pdfResultado.empatados.forEach((e) => {
      if ((usadosSis.has(e.ca) || usadosPdf.has(e.mov)) && !autosRotos.includes(e.ca._id)) {
        autosRotos.push(e.ca._id);
      }
    });

    return { empatesManual, gruposManual, autosRotos };
  }

  // Decisión guardada de las devoluciones canceladas entre sí (se lee ANTES de
  // empatar, porque decide qué movimientos entran al empate automático).
  reversosCanceladosGuardados() {
    const guardado = leerRelacionesManuales(this.props.location.state.id);
    return (guardado && guardado.reversosCancelados) || [];
  }

  persistirRelacionesManuales() {
    const { empatesManual, gruposManual, autosRotos, reversosCancelados } = this.state;
    guardarRelacionesManuales(this.props.location.state.id, {
      reversosCancelados,
      empates: empatesManual.map((p) => ({
        caId: p.ca._id,
        movKey: claveMovimientoPdf(p.mov),
        dif: p.dif || 0,
      })),
      grupos: gruposManual.map((g) => {
        const tipoComp = this.tipoComplemento(g);
        return {
          principalTipo: g.principal.tipo,
          principalKey:
            g.principal.tipo === "sis"
              ? g.principal.obj._id
              : claveMovimientoPdf(g.principal.obj),
          complementos: g.complementos.map((obj) =>
            tipoComp === "sis" ? obj._id : claveMovimientoPdf(obj)
          ),
        };
      }),
      autosRotos,
    });
  }

  async consultarDatos(consultarInfo) {
    await axios
    .post(
      "conciliaciones/datosParaConciliacion",
      {
        empresaId: this.props.empresaId,
        conciliacionId: this.props.location.state.id,
      },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      if (res.data.success !== 2) {
        message.error(
          "Error no se encontro informacion para la conciliacion"
        );
      } else {

        let totalCargos = 0
        let totalAbonos = 0

          const nuevosCargosAbonos = res.data.cargosAbonos.map((valueCargoAbono) => {
              let cargo
              let abono

              if(valueCargoAbono.cargo){
                  cargo = valueCargoAbono.montoMoneda || valueCargoAbono.monto
                  if(valueCargoAbono.conciliado){
                    totalCargos += valueCargoAbono.montoMoneda || valueCargoAbono.monto
                  }
              }else{
                  abono = valueCargoAbono.montoMoneda || valueCargoAbono.monto
                  if(valueCargoAbono.conciliado){
                    totalAbonos += valueCargoAbono.montoMoneda || valueCargoAbono.monto
                  }
              }

              return {
                  ...valueCargoAbono,
                  cargo,
                  abono,
              }
          })
        const fechaInicial = res.data.conciliacion.fechaInicial || null;
        const fechaFinal = res.data.conciliacion.fechaFinal || null;
        const cambioPeriodo =
          String(fechaInicial) !== String(this.state.fechaInicial) ||
          String(fechaFinal) !== String(this.state.fechaFinal);
        this.setState({ cargosAbonos: nuevosCargosAbonos, totalCargos, totalAbonos, saldoInicial: res.data.conciliacion.saldoInicial, saldoFinal: res.data.conciliacion.saldoFinal, saldosCongelados: !!res.data.conciliacion.saldosCongelados, cuentaAjusteConciliacionId: res.data.cuentaAjusteConciliacionId, ajusteMaxConciliacion: res.data.ajusteMaxConciliacion, monedaBanco: res.data.monedaBanco, fechaInicial, fechaFinal }, () => {
          // Si el usuario cambió el periodo con un PDF ya cargado, se re-acomodan sus movimientos.
          if (cambioPeriodo) this.reempatarPdf();
        });
        if(consultarInfo){
          this.formRefDatosConciliacion.current.setFieldsValue({
            saldoFinal: res.data.conciliacion.saldoFinal,
            referencia: res.data.conciliacion.referencia,
            fechaInicial: moment(res.data.conciliacion.fechaInicial),
            fechaFinal: moment(res.data.conciliacion.fechaFinal,)
          });
        }
      }
    });
  }

  onFinishFailed(e) {
   ErrorItem(e);
  }
  onFinish() {
    const diferencia = round2Decimals((this.state.saldoInicial + this.state.totalCargos - this.state.totalAbonos) - this.state.saldoFinal)
    if (diferencia !== 0)
      return message.info(
        "Para guardar la conciliación la diferencia necesita ser 0"
      );
    this.setState({ loading: true });
    axios
      .post(
        "conciliaciones/guardarConciliacion",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha guardado una conciliación");
          cachePdfConciliacion.delete(this.props.location.state.id);
          borrarRelacionesManuales(this.props.location.state.id);
          this.atras()
        } else if (res.data.success === 1) {
          message.error("No se pudo guardar la conciliacion");
        } else {
          message.error("Hubo un error y no se guardo la conciliacion");
        }
        this.setState({ loading: false });
      });
  }
  atras() {
    this.props.history.goBack();
  }

  // El PDF de la póliza se ve en un modal, sin salir de la conciliación.
  abrirPdfPoliza = (polizaId) => {
    this.setState({ modalPdfPoliza: true, polizaIdPdf: polizaId });
  };
  cerrarPdfPoliza = () => {
    this.setState({ modalPdfPoliza: false, polizaIdPdf: null });
  };

  proyectoMasFrecuente() {
    const conteo = new Map();
    this.state.cargosAbonos.forEach((ca) => {
      if (!ca.proyectoId) return;
      const id = ca.proyectoId.toString();
      conteo.set(id, (conteo.get(id) || 0) + 1);
    });
    let mejor;
    let max = 0;
    conteo.forEach((count, id) => {
      if (count > max) {
        max = count;
        mejor = id;
      }
    });
    return mejor;
  }

  esMXN(moneda) {
    return !moneda || moneda.abreviacion === "MXN";
  }

  abrirModalAjuste() {
    this.setState({ modalAjuste: true, tcAjuste: null }, () => {
      this.formRefAjuste.current.setFieldsValue({
        fechaPoliza: moment(),
        concepto: "Ajuste por diferencia de conciliación bancaria",
        proyectoId: this.proyectoMasFrecuente(),
        cuentaAjusteId: this.state.cuentaAjusteConciliacionId,
        tipoDeCambio: undefined,
      });
    });
  }

  cerrarModalAjuste() {
    this.setState({ modalAjuste: false });
  }

  // Diferencia actual de la conciliación, en la moneda de la cuenta.
  diferenciaConciliacion() {
    const { saldoInicial, totalCargos, totalAbonos, saldoFinal } = this.state;
    return round2Decimals(saldoInicial + totalCargos - totalAbonos - saldoFinal);
  }

  async confirmarAjuste() {
    let values;
    try {
      values = await this.formRefAjuste.current.validateFields();
    } catch (err) {
      return;
    }

    if (!this.esMXN(this.state.monedaBanco)) {
      const tc = Number(values.tipoDeCambio);
      if (!Number.isFinite(tc) || tc <= 0) {
        message.error("El tipo de cambio debe ser mayor a 0");
        return;
      }
      const diferencia = Math.abs(this.diferenciaConciliacion());
      const ajusteMXN = round2Decimals(diferencia * tc);
      const tolerancia = this.toleranciaConciliacion();
      if (ajusteMXN > tolerancia) {
        MensajeError({
          message: "No es posible crear la póliza de ajuste",
          description: `La diferencia de ${dineroDisabledMask(diferencia)} ${
            this.state.monedaBanco.abreviacion
          } equivale a ${dineroDisabledMask(ajusteMXN)} MXN con un tipo de cambio de ${tc}.\nEl ajuste máximo de conciliación configurado es de: ${dineroDisabledMask(
            tolerancia
          )} MXN.`,
        });
        return;
      }
    }
    this.setState({ guardandoAjuste: true });
    await axios
      .post(
        "conciliaciones/agregarPolizaAjusteAConciliacion",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
          proyectoId: values.proyectoId,
          concepto: values.concepto,
          fechaPoliza: values.fechaPoliza,
          cuentaAjusteId: values.cuentaAjusteId,
          tipoDeCambio: values.tipoDeCambio,
        },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        this.setState({ guardandoAjuste: false });
        if (res.data.success === 2) {
          message.success("Se ha creado la póliza de ajuste y el movimiento quedó conciliado");
          NotificacionPolizas(res.data.polizasId);
          this.setState({ modalAjuste: false });
          await this.consultarDatos(false);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo crear la póliza de ajuste");
        } else {
          message.error("Hubo un error y no se creó la póliza de ajuste");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }

  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarCuentasContables().then(() => {
      if (typeof codigo === "string") {
        this.formRefAjuste.current.setFieldsValue({ cuentaAjusteId: codigo });
      }
    });
  }

  async subirExcel(file) {
    if (
      file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      !file.name?.endsWith(".xlsx")
    ) {
      message.error("El archivo debe ser un Excel (.xlsx)");
      return;
    }

    this.setState({ loading: true });

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const hoja = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[workbook.SheetNames[0]]);

      const { cargosAbonos } = this.state;
      let cambios = 0;
      let noEncontrados = 0;

      for (const fila of hoja) {
        const concepto = fila["Concepto"] ? String(fila["Concepto"]).trim() : null;
        const conciliadoExcel = String(fila["Conciliado"] ?? "").trim().toLowerCase();
        const debeConciliar = conciliadoExcel === "sí" || conciliadoExcel === "si" || conciliadoExcel === "1" || conciliadoExcel === "true";

        if (!concepto) continue;

        const idx = cargosAbonos.findIndex((ca) => ca.concepto?.trim() === concepto);
        if (idx === -1) {
          noEncontrados++;
          continue;
        }

        const actual = cargosAbonos[idx];
        if (actual.conciliado === debeConciliar) continue;

        const endpoint = debeConciliar
          ? "conciliaciones/agregarCargoAbonoAConciliacion"
          : "conciliaciones/eliminarCargoAbonoAConciliacion";

        const res = await axios.post(
          endpoint,
          {
            empresaId: this.props.empresaId,
            conciliacionId: this.props.location.state.id,
            cargoAbonoId: actual._id,
          },
          { headers: this.props.headersToken }
        );

        if (res.data.success === 2) cambios++;
        else message.warning(`No se pudo actualizar: ${concepto}`);
      }

      await this.consultarDatos(false);
      this.setState({ loading: false });

      if (noEncontrados > 0) message.warning(`${noEncontrados} movimiento(s) del Excel no se encontraron en la conciliación`);
      if (cambios > 0) message.success(`${cambios} movimiento(s) actualizados correctamente`);
      else if (noEncontrados === 0) message.info("No hubo cambios que aplicar");
    };
  }

  candidatosPdf(pdfResultado) {
    if (pdfResultado.ordenPdf) return pdfResultado.ordenPdf;
    return [
      ...pdfResultado.empatados.map((e) => e.mov),
      ...pdfResultado.sobrantes,
      ...(pdfResultado.posteriores || []),
      ...(pdfResultado.cancelados || []),
    ];
  }

  claveReverso(par) {
    return claveMovimientoPdf(par.devolucion);
  }

  empatarPdf(candidatos, reversosCancelados = this.state.reversosCancelados) {
    const { fechaInicial, fechaFinal, ventanaDias, cargosAbonos } = this.state;
    const inicial = fechaInicial && moment(fechaInicial).isValid() ? moment(fechaInicial) : null;
    const final = fechaFinal && moment(fechaFinal).isValid() ? moment(fechaFinal) : null;

    const reversos = candidatos
      .filter((mov) => mov.reversoDe && candidatos.includes(mov.reversoDe))
      .map((mov) => ({ original: mov.reversoDe, devolucion: mov }));
    const cancelados = [];
    reversos.forEach((par) => {
      if (reversosCancelados.includes(this.claveReverso(par))) cancelados.push(par.original, par.devolucion);
    });
    const enReverso = (mov) => reversos.some((par) => par.original === mov || par.devolucion === mov);
    const alFinalLosReversos = (lista) => [
      ...lista.filter((mov) => !enReverso(mov)),
      ...lista.filter(enReverso),
    ];

    const enPeriodo = [];
    const anteriores = [];
    const posteriores = [];
    candidatos.forEach((mov) => {
      if (cancelados.includes(mov)) return;
      const fecha = mov.fecha ? moment(mov.fecha) : null;
      if (fecha && final && fecha.isAfter(final, "day")) posteriores.push(mov);
      else if (fecha && inicial && fecha.isBefore(inicial, "day")) anteriores.push(mov);
      else enPeriodo.push(mov);
    });
    const resultado = empatarMovimientos(
      cargosAbonos,
      [...alFinalLosReversos(enPeriodo), ...alFinalLosReversos(anteriores)],
      { ventanaDias }
    );
    return { ...resultado, posteriores, reversos, cancelados, ordenPdf: candidatos };
  }

  cambiarTratamientoReverso(par, separado) {
    const clave = this.claveReverso(par);
    const movs = [par.original, par.devolucion];
    this.setState(
      (s) => ({
        reversosCancelados: separado
          ? s.reversosCancelados.filter((c) => c !== clave)
          : [...s.reversosCancelados.filter((c) => c !== clave), clave],
        empatesManual: separado ? s.empatesManual : s.empatesManual.filter((p) => !movs.includes(p.mov)),
        gruposManual: separado
          ? s.gruposManual
          : s.gruposManual.filter(
              (g) => !movs.includes(g.principal.obj) && !g.complementos.some((o) => movs.includes(o))
            ),
      }),
      () => {
        this.persistirRelacionesManuales();
        this.reempatarPdf();
      }
    );
  }

  // Re-empata el PDF ya cargado (sin re-subirlo) y recupera las relaciones manuales.
  reempatarPdf() {
    const { pdfResultado } = this.state;
    if (!pdfResultado) return;
    const resultado = this.empatarPdf(this.candidatosPdf(pdfResultado));
    this.setState({
      pdfResultado: resultado,
      ...this.rehidratarRelacionesManuales(resultado),
    });
  }

  // Cambia la brecha de días permitida y re-empata sobre el mismo PDF ya cargado.
  cambiarVentanaDias(ventanaDias) {
    this.setState({ ventanaDias }, () => this.reempatarPdf());
  }

  async leerPdfBanco(file) {
    if (file.type !== "application/pdf" && !file.name?.endsWith(".pdf")) {
      message.error("El archivo debe ser un PDF");
      return;
    }

    this.setState({ loading: true });
    try {
      const lineas = await extraerLineasDePdf(file);
      // Útil para calibrar el parser de cada banco: copia este output y compártelo.
      console.log("Líneas extraídas del PDF:", lineas);
      const anioRef = moment(this.state.cargosAbonos[0]?.fechaRegistro || undefined).year();
      const { movimientos: candidatos, plantilla, autodetectada, porClaveSat, conflicto } =
        extraerMovimientosBanco(lineas, anioRef, { claveSatCuenta: this.state.claveSatCuenta });
      console.log(
        `Plantilla usada: ${plantilla.nombre} (por banco de la cuenta: ${!!porClaveSat}, auto-detectada: ${autodetectada})`,
        candidatos
      );
      if (conflicto) {
        this.setState({ loading: false });
        this.avisarPdfDeOtroBanco(conflicto);
        return;
      }

      if (candidatos.length === 0) {
        message.warning("No se detectaron movimientos (fecha + monto) en el PDF");
        this.setState({ loading: false, pdfLineas: lineas, pdfPlantillaId: plantilla.id });
        return;
      }

      const reversosCancelados = this.reversosCanceladosGuardados();
      const resultado = this.empatarPdf(candidatos, reversosCancelados);
      const manuales = { ...this.rehidratarRelacionesManuales(resultado), reversosCancelados };
      const pdfCargado = { resultado, lineas, plantillaId: plantilla.id, autodetectada };
      if (
        manuales.empatesManual.length + manuales.gruposManual.length + manuales.autosRotos.length +
          resultado.reversos.filter((par) => reversosCancelados.includes(this.claveReverso(par))).length >
        0
      ) {
        this.setState({ loading: false, modalHistorialPdf: { pdfCargado, manuales } });
        return;
      }
      this.aplicarPdfCargado(pdfCargado, manuales);
    } catch (err) {
      console.error("Error al leer el PDF del banco:", err);
      message.error("No se pudo leer el PDF");
      this.setState({ loading: false });
    }
  }

  aplicarPdfCargado(pdfCargado, manuales) {
    this.setState({
      loading: false,
      modalHistorialPdf: null,
      pdfResultado: pdfCargado.resultado,
      pdfLineas: pdfCargado.lineas,
      pdfPlantillaId: pdfCargado.plantillaId,
      pdfAutodetectada: pdfCargado.autodetectada,
      ...manuales,
    }, () => this.abrirModalCentavos());
  }

  continuarHistorialPdf() {
    const { pdfCargado, manuales } = this.state.modalHistorialPdf;
    this.aplicarPdfCargado(pdfCargado, manuales);
    const recuperadas = manuales.empatesManual.length + manuales.gruposManual.length;
    if (recuperadas > 0) {
      message.info(`Se recuperaron ${recuperadas} relación(es) que ya habías hecho a mano con este estado de cuenta`);
    }
  }

  empezarDeCeroPdf() {
    const { pdfCargado } = this.state.modalHistorialPdf;
    const id = this.props.location.state.id;
    borrarRelacionesManuales(id);
    cachePdfConciliacion.delete(id);
    const resultado = this.empatarPdf(this.candidatosPdf(pdfCargado.resultado), []);
    this.aplicarPdfCargado(
      { ...pdfCargado, resultado },
      { empatesManual: [], gruposManual: [], autosRotos: [], reversosCancelados: [] }
    );
    message.success("Se borró el avance anterior: el PDF se cargó desde 0");
  }

  renderModalHistorialPdf() {
    const datos = this.state.modalHistorialPdf;
    const relaciones = datos ? datos.manuales.empatesManual.length + datos.manuales.gruposManual.length : 0;
    const deshechos = datos ? datos.manuales.autosRotos.length : 0;
    const canceladas = datos
      ? datos.pdfCargado.resultado.reversos.filter((par) =>
          datos.manuales.reversosCancelados.includes(this.claveReverso(par))
        ).length
      : 0;
    return (
      <ModalItem
        title="Este estado de cuenta ya tiene avance"
        visible={!!datos}
        onCancel={() => this.setState({ modalHistorialPdf: null })}
        spinning={false}
        width={480}
        paddingTop
      >
        <p style={{ marginBottom: 8 }}>
          Ya habías trabajado con este PDF en esta conciliación. ¿Quieres continuar con lo que llevabas o
          empezar de 0?
        </p>
        <ul style={{ fontSize: 12, color: "#595959", paddingLeft: 18, marginBottom: 8 }}>
          {relaciones > 0 && (
            <li>
              <b>{relaciones}</b> relación{relaciones === 1 ? "" : "es"} hecha{relaciones === 1 ? "" : "s"} a mano
            </li>
          )}
          {deshechos > 0 && (
            <li>
              <b>{deshechos}</b> empate{deshechos === 1 ? "" : "s"} automático{deshechos === 1 ? "" : "s"} que deshiciste
            </li>
          )}
          {canceladas > 0 && (
            <li>
              <b>{canceladas}</b> devolución{canceladas === 1 ? "" : "es"} del banco cancelada{canceladas === 1 ? "" : "s"} con su retiro
            </li>
          )}
        </ul>
        <p style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 0 }}>
          Empezar de 0 borra ese avance y vuelve a empatar el PDF como nuevo. Los movimientos que ya
          conciliaste con "Conciliar Cuentas" siguen conciliados.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 20,
            paddingTop: 12,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <ButtonItem blanco lessTime onClick={this.empezarDeCeroPdf.bind(this)}>
            Empezar de 0
          </ButtonItem>
          <ButtonItem type="primary" lessTime onClick={this.continuarHistorialPdf.bind(this)}>
            Continuar
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }

  // Estado conciliado ACTUAL de un movimiento del sistema: se lee de cargosAbonos
  // por _id (no de la referencia guardada en pdfResultado, que puede quedar obsoleta
  // tras consultarDatos). Así la dual-list refleja lo que se marca/desmarca en el
  // tab de Movimientos.
  conciliadoActual(ca) {
    const actual = this.state.cargosAbonos.find((c) => c._id === ca._id);
    return actual ? !!actual.conciliado : !!ca.conciliado;
  }

  // Diferencia máxima que la empresa acepta al CERRAR una conciliación
  toleranciaConciliacion() {
    const raw = this.state.ajusteMaxConciliacion;
    if (raw === null || raw === undefined || raw === "") return 0.5;
    const valor = Number(raw);
    return Number.isFinite(valor) ? Math.abs(valor) : 0.5;
  }

  montoSis(ca) {
    return ca.cargo != null ? ca.cargo : ca.abono;
  }
  montoPdf(mov) {
    return mov.monto;
  }
  montoCard(card) {
    return card.tipo === "sis" ? this.montoSis(card.obj) : this.montoPdf(card.obj);
  }
  idCard(card) {
    return card.tipo === "sis" ? this.idCa(card.obj) : this.idMov(card.obj);
  }
  datosCard(card) {
    return card.tipo === "sis" ? this.datosTarjetaSistema(card.obj) : this.datosTarjetaPdf(card.obj);
  }

  naturalezaCard(card) {
    if (!card || !card.obj) return null;
    return card.tipo === "sis" ? (card.obj.cargo != null ? "cargo" : "abono") : card.obj.tipo || null;
  }
  mismaNaturaleza(a, b) {
    const na = this.naturalezaCard(a);
    const nb = this.naturalezaCard(b);
    return !na || !nb || na === nb;
  }
  etiquetaCard(card) {
    return (this.datosCard(card).tipoLabel || "movimiento").toLowerCase();
  }

  cardNoRecibeDrag(id) {
    const { dragId } = this.state;
    if (!dragId || dragId === id) return false;
    const origen = this.resolverCardDnd(dragId);
    const destino = this.resolverCardDnd(id);
    if (!origen.obj || !destino.obj) return false;
    if (origen.tipo === destino.tipo) return false; 
    return !this.mismaNaturaleza(origen, destino);
  }
  tipoComplemento(grupo) {
    return grupo.principal.tipo === "sis" ? "pdf" : "sis";
  }
  sumaGrupo(grupo) {
    const tipo = this.tipoComplemento(grupo);
    return round2Decimals(
      grupo.complementos.reduce((total, obj) => total + this.montoCard({ tipo, obj }), 0)
    );
  }
  restanteGrupo(grupo) {
    return round2Decimals(this.montoCard(grupo.principal) - this.sumaGrupo(grupo));
  }
  grupoCompleto(grupo) {
    return Math.abs(this.restanteGrupo(grupo)) <= this.toleranciaConciliacion();
  }
  casDeGrupo(grupo) {
    return grupo.principal.tipo === "sis" ? [grupo.principal.obj] : grupo.complementos;
  }
  cardsLibres(tipo) {
    const { pdfResultado, empatesManual, gruposManual, autosRotos } = this.state;
    if (!pdfResultado) return [];
    const { empatados, noEmpatados, sobrantes } = pdfResultado;
    const rotos = empatados.filter((e) => autosRotos.includes(e.ca._id));
    const enGrupos = [];
    gruposManual.forEach((g) => {
      if (g.principal.tipo === tipo) enGrupos.push(g.principal.obj);
      if (this.tipoComplemento(g) === tipo) g.complementos.forEach((o) => enGrupos.push(o));
    });
    if (tipo === "sis") {
      const usados = empatesManual.map((p) => p.ca);
      return [...noEmpatados, ...rotos.map((e) => e.ca)].filter(
        (ca) => !this.conciliadoActual(ca) && !usados.includes(ca) && !enGrupos.includes(ca)
      );
    }
    const usados = empatesManual.map((p) => p.mov);
    return [...sobrantes, ...rotos.map((e) => e.mov)].filter(
      (m) => !usados.includes(m) && !enGrupos.includes(m)
    );
  }

  grupoDeCard(card) {
    return this.state.gruposManual.find(
      (g) =>
        (g.principal.tipo === card.tipo && g.principal.obj === card.obj) ||
        (this.tipoComplemento(g) === card.tipo && g.complementos.includes(card.obj))
    );
  }
  movimientosPorConciliar() {
    const { pdfResultado, empatesManual, gruposManual, autosRotos } = this.state;
    if (!pdfResultado) return [];
    const autos = pdfResultado.empatados
      .filter((e) => !autosRotos.includes(e.ca._id))
      .map((e) => e.ca);
    const manuales = empatesManual.map((p) => p.ca);
    const agrupados = gruposManual
      .filter((g) => this.grupoCompleto(g))
      .reduce((acc, g) => [...acc, ...this.casDeGrupo(g)], []);
    const vistos = new Set();
    return [...autos, ...manuales, ...agrupados].filter((ca) => {
      if (this.conciliadoActual(ca) || vistos.has(ca._id)) return false;
      vistos.add(ca._id);
      return true;
    });
  }

  listasDnd() {
    const { empatados, noEmpatados } = this.state.pdfResultado;
    return {
      sisAll: [...empatados.map((e) => e.ca), ...noEmpatados],
      pdfAll: this.candidatosPdf(this.state.pdfResultado),
    };
  }
  idCa(ca) {
    return `sis:${ca._id}`;
  }
  idMov(mov) {
    return `pdf:${this.listasDnd().pdfAll.indexOf(mov)}`;
  }
  resolverCardDnd(rawId) {
    const id = (rawId || "").toString();
    const { sisAll, pdfAll } = this.listasDnd();
    if (id.startsWith("sis:")) return { tipo: "sis", obj: sisAll.find((ca) => ca._id === id.slice(4)) };
    if (id.startsWith("pdf:")) return { tipo: "pdf", obj: pdfAll[parseInt(id.slice(4), 10)] };
    return { tipo: null, obj: null };
  }

  // D&D sobre todas las cards: cualquier card del sistema soltada sobre una del
  // PDF (o viceversa) las empareja manualmente; rompe los empates previos que
  // usaran cualquiera de las dos.
  // Mientras se arrastra, la manita cerrada se fuerza en toda la página (Styles.css)
  // para que el cursor no cambie según lo que quede debajo y no parpadee.
  marcarArrastre(activo) {
    document.body.classList.toggle("conciliacion-arrastrando", activo);
  }

  onDragStartEmpate = (event) => {
    this.marcarArrastre(true);
    this.setState({ dragId: event.active?.id?.toString() || null });
  };

  onDragCancelEmpate = () => {
    this.marcarArrastre(false);
    this.setState({ dragId: null });
  };

  // Desplaza la pantalla hasta una sección del resultado del PDF; si está
  // plegada, primero la despliega.
  irASeccion(clave) {
    const desplazar = () => {
      const nodo = this.seccionesRef[clave]?.current;
      if (nodo) nodo.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    this.setState(
      (s) => ({
        seccionIndice: clave,
        seccionesAbiertas: s.seccionesAbiertas.includes(clave)
          ? s.seccionesAbiertas
          : [...s.seccionesAbiertas, clave],
      }),
      desplazar
    );
  }

  irAlInicio() {
    this.inicioRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  alternarSeccion(clave) {
    this.setState((s) => ({
      seccionesAbiertas: s.seccionesAbiertas.includes(clave)
        ? s.seccionesAbiertas.filter((c) => c !== clave)
        : [...s.seccionesAbiertas, clave],
    }));
  }

  // Sección desplegable del resultado del PDF (clave = entrada del índice); el
  // título lleva a la derecha una flecha para volver al inicio.
  renderSeccionPdf(clave, { titulo, detalle, style }, contenido) {
    // La barra fija (renderBarraSeccionFija) repite el título de la sección en curso.
    this.titulosSeccion[clave] = { titulo, detalle };
    return (
      // scrollMarginTop compensa el header fijo (64px) al desplazarse a la sección.
      <div ref={this.seccionesRef[clave]} style={{ scrollMarginTop: 80 }}>
        <Collapse
          style={{ borderRadius: 8, marginBottom: 12, ...style }}
          activeKey={this.state.seccionesAbiertas.includes(clave) ? [clave] : []}
          onChange={() => this.alternarSeccion(clave)}
        >
          <Collapse.Panel
            key={clave}
            header={
              <span style={{ fontSize: 13, fontWeight: 600, color: "#595959" }}>
                {titulo}
                {detalle && (
                  <span style={{ fontWeight: 400, color: "#8c8c8c", fontSize: 12, marginLeft: 8 }}>{detalle}</span>
                )}
              </span>
            }
            extra={
              <Tooltip title="Volver al inicio">
                <button
                  type="button"
                  className="conciliacion-ir-inicio"
                  onClick={(e) => {
                    e.stopPropagation(); // no pliega/despliega la sección
                    this.irAlInicio();
                  }}
                  onKeyPress={(e) => e.stopPropagation()}
                >
                  <VerticalAlignTopOutlined />
                </button>
              </Tooltip>
            }
          >
            {contenido}
          </Collapse.Panel>
        </Collapse>
      </div>
    );
  }
  // Barra fija con el encabezado de la sección que se está recorriendo
  renderBarraSeccionFija() {
    const fija = this.state.seccionFija;
    const datos = fija && this.titulosSeccion[fija.clave];
    if (!fija || !datos) return null;
    return createPortal(
      <div
        style={{ position: "fixed", top: fija.top, left: fija.left, width: fija.width, zIndex: 10 }}
      >
        <div
          role="button"
          onClick={() => {
            this.alternarSeccion(fija.clave);
            this.seccionesRef[fija.clave]?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            height: ALTO_BARRA_SECCION,
            padding: "0 16px",
            background: "#fafafa",
            border: "1px solid #d9d9d9",
            borderRadius: 8,
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
            cursor: "pointer",
          }}
        >
          <RightOutlined rotate={90} style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.85)" }} />
          <span
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: 13,
              fontWeight: 600,
              color: "#595959",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {datos.titulo}
            {datos.detalle && (
              <span style={{ fontWeight: 400, color: "#8c8c8c", fontSize: 12, marginLeft: 8 }}>{datos.detalle}</span>
            )}
          </span>
          <Tooltip title="Volver al inicio">
            <button
              type="button"
              className="conciliacion-ir-inicio"
              onClick={(e) => {
                e.stopPropagation(); 
                this.irAlInicio();
              }}
            >
              <VerticalAlignTopOutlined />
            </button>
          </Tooltip>
        </div>
      </div>,
      document.body
    );
  }

  onDragEndEmpate = (event) => {
    const { active, over } = event;
    this.marcarArrastre(false);
    this.setState({ dragId: null });
    if (!over || active.id === over.id) return;

    const a = this.resolverCardDnd(active.id);
    const b = this.resolverCardDnd(over.id);
    if (!a.obj || !b.obj) return;
    if (a.tipo === b.tipo) return; 

    if (!this.mismaNaturaleza(a, b)) {
      message.info(
        `No puedes relacionar un ${this.etiquetaCard(a)} con un ${this.etiquetaCard(
          b
        )}: sólo se concilian movimientos del mismo tipo.`
      );
      return;
    }

    const grupoDestino = this.grupoDeCard(b) || this.grupoDeCard(a);
    if (grupoDestino) {
      const card = this.grupoDeCard(b) ? a : b;
      this.agregarAGrupo(grupoDestino, card);
      return;
    }

    const ca = a.tipo === "sis" ? a.obj : b.obj;
    const mov = a.tipo === "pdf" ? a.obj : b.obj;
    this.intentarEmparejar(ca, mov);
  };

  intentarEmparejar(ca, mov) {
    if (this.conciliadoActual(ca)) {
      message.info("Ese movimiento del sistema ya está conciliado");
      return;
    }
    const dif = round2Decimals(Math.abs(this.montoSis(ca) - this.montoPdf(mov)));
    if (dif === 0) {
      this.emparejarManual(ca, mov);
      return;
    }
    this.setState({
      modalEmpateVisible: true,
      modalEmpate: {
        ca,
        mov,
        dif,
        modo: dif <= this.toleranciaConciliacion() ? "tolerancia" : "excede",
      },
    });
  }
  cerrarModalEmpate() {
    this.setState({ modalEmpateVisible: false });
  }

  confirmarModalEmpate() {
    const datos = this.state.modalEmpate;
    if (!datos) return;
    if (datos.modo === "tolerancia") {
      this.setState({ modalEmpateVisible: false });
      this.emparejarManual(datos.ca, datos.mov, datos.dif);
      return;
    }
    if (datos.paso !== 2) {
      const principal =
        this.montoSis(datos.ca) >= this.montoPdf(datos.mov)
          ? { tipo: "sis", obj: datos.ca }
          : { tipo: "pdf", obj: datos.mov };
      const inicial = principal.tipo === "sis" ? datos.mov : datos.ca;
      this.setState({
        modalEmpate: { ...datos, paso: 2, principal },
        seleccionGrupo: [inicial],
        busquedaGrupo: "",
      });
      return;
    }
    this.crearGrupoDesdeSeleccion(datos.principal, this.state.seleccionGrupo);
  }

  alternarSeleccionGrupo(obj) {
    const seleccion = this.state.seleccionGrupo;
    this.setState({
      seleccionGrupo: seleccion.includes(obj)
        ? seleccion.filter((o) => o !== obj)
        : [...seleccion, obj],
    });
  }

  // Selección masiva
  alternarSeleccionVisibles(visibles, marcar) {
    const seleccion = this.state.seleccionGrupo;
    this.setState({
      seleccionGrupo: marcar
        ? [...seleccion, ...visibles.filter((obj) => !seleccion.includes(obj))]
        : seleccion.filter((obj) => !visibles.includes(obj)),
    });
  }
  crearGrupoDesdeSeleccion(principal, seleccionados) {
    if (!seleccionados.length) {
      message.info("Selecciona al menos un movimiento");
      return;
    }
    const tipoComp = principal.tipo === "sis" ? "pdf" : "sis";
    const montoPrincipal = this.montoCard(principal);
    const suma = round2Decimals(
      seleccionados.reduce((total, obj) => total + this.montoCard({ tipo: tipoComp, obj }), 0)
    );
    const diferencia = round2Decimals(Math.abs(montoPrincipal - suma));
    const tolerancia = this.toleranciaConciliacion();

    if (diferencia > tolerancia) {
      MensajeError({
        message: "No es posible conciliar estos movimientos",
        description: `El movimiento principal es de: ${dineroDisabledMask(
          montoPrincipal
        )}.\nEl ajuste máximo de conciliación configurado es de: ${dineroDisabledMask(
          tolerancia
        )}.`,
      });
      return;
    }

    const cards = [principal, ...seleccionados.map((obj) => ({ tipo: tipoComp, obj }))];
    const estado = this.liberarCards(cards);
    estado.gruposManual = [...estado.gruposManual, { principal, complementos: seleccionados }];
    this.setState({ ...estado, modalEmpateVisible: false, seleccionGrupo: [], busquedaGrupo: "" });
    message.success(
      diferencia === 0
        ? `${seleccionados.length} movimientos relacionados: suman ${dineroDisabledMask(montoPrincipal)}.`
        : `${seleccionados.length} movimientos relacionados con una diferencia de ${dineroDisabledMask(
            diferencia
          )} (dentro del margen).`
    );
  }

  liberarCards(cards) {
    const incluye = (tipo, obj) => cards.some((c) => c.tipo === tipo && c.obj === obj);
    const rotos = new Set(this.state.autosRotos);
    this.state.pdfResultado.empatados.forEach((e) => {
      if (incluye("sis", e.ca) || incluye("pdf", e.mov)) rotos.add(e.ca._id);
    });
    const empatesManual = this.state.empatesManual.filter(
      (p) => !incluye("sis", p.ca) && !incluye("pdf", p.mov)
    );
    const gruposManual = this.state.gruposManual
      .filter((g) => !incluye(g.principal.tipo, g.principal.obj))
      .map((g) => ({
        ...g,
        complementos: g.complementos.filter((obj) => !incluye(this.tipoComplemento(g), obj)),
      }))
      .filter((g) => g.complementos.length > 0);
    return { autosRotos: [...rotos], empatesManual, gruposManual };
  }

  emparejarManual(ca, mov, dif) {
    if (this.conciliadoActual(ca)) {
      message.info("Ese movimiento del sistema ya está conciliado");
      return;
    }
    const estado = this.liberarCards([
      { tipo: "sis", obj: ca },
      { tipo: "pdf", obj: mov },
    ]);
    estado.empatesManual = [...estado.empatesManual, { ca, mov, dif: dif || 0 }];
    this.setState(estado);
    message.success(
      dif
        ? `Movimientos emparejados con una diferencia de ${dineroDisabledMask(dif)}`
        : "Movimientos emparejados manualmente"
    );
  }
  crearGrupo(ca, mov) {
    const montoSis = this.montoSis(ca);
    const montoPdf = this.montoPdf(mov);
    const sisEsPrincipal = montoSis >= montoPdf;
    const estado = this.liberarCards([
      { tipo: "sis", obj: ca },
      { tipo: "pdf", obj: mov },
    ]);
    const grupo = {
      principal: sisEsPrincipal ? { tipo: "sis", obj: ca } : { tipo: "pdf", obj: mov },
      complementos: [sisEsPrincipal ? mov : ca],
    };
    estado.gruposManual = [...estado.gruposManual, grupo];
    this.setState(estado);
    message.success(
      `Movimiento principal de ${dineroDisabledMask(Math.max(montoSis, montoPdf))}. Arrástrale más movimientos: faltan ${dineroDisabledMask(
        round2Decimals(Math.abs(montoSis - montoPdf))
      )}.`
    );
  }

  agregarAGrupo(grupo, card) {
    if (card.tipo !== this.tipoComplemento(grupo)) {
      message.info("Sólo puedes agregar movimientos del lado contrario al principal");
      return;
    }
    if (!this.mismaNaturaleza(grupo.principal, card)) {
      message.info(
        `Ese grupo es de ${this.etiquetaCard(grupo.principal)}s: sólo puedes agregarle movimientos del mismo tipo.`
      );
      return;
    }
    if (card.tipo === "sis" && this.conciliadoActual(card.obj)) {
      message.info("Ese movimiento del sistema ya está conciliado");
      return;
    }
    if (grupo.complementos.includes(card.obj)) return;

    const nuevos = [...grupo.complementos, card.obj];
    const principal = this.montoCard(grupo.principal);
    const suma = round2Decimals(
      nuevos.reduce((total, obj) => total + this.montoCard({ tipo: card.tipo, obj }), 0)
    );
    const tolerancia = this.toleranciaConciliacion();
    const excedente = round2Decimals(suma - principal);
    if (excedente > tolerancia) {
      MensajeError({
        message: "Rebasas el límite de ajuste de centavos en conciliación que tienes configurado",
        description: `Con ese movimiento la suma quedaría en ${dineroDisabledMask(
          suma
        )} y el movimiento principal es de ${dineroDisabledMask(
          principal
        )}: un excedente de ${dineroDisabledMask(excedente)}. El límite configurado para tu empresa es de ${dineroDisabledMask(
          tolerancia
        )}, así que esta relación no puede cuadrar.`,
      });
      return;
    }
    const estado = this.liberarCards([card]);
    estado.gruposManual = estado.gruposManual.map((g) =>
      g.principal.tipo === grupo.principal.tipo && g.principal.obj === grupo.principal.obj
        ? { ...g, complementos: nuevos }
        : g
    );
    this.setState(estado);

    const restante = round2Decimals(principal - suma);
    if (Math.abs(restante) <= this.toleranciaConciliacion()) {
      message.success(
        restante === 0
          ? `Conciliación completa: ${nuevos.length} movimientos suman ${dineroDisabledMask(principal)}.`
          : `Conciliación completa con una diferencia de ${dineroDisabledMask(Math.abs(restante))} (dentro del margen).`
      );
    } else {
      message.info(`Faltan ${dineroDisabledMask(restante)} para completar el movimiento principal.`);
    }
  }

  deshacerGrupo(grupo) {
    this.setState({
      gruposManual: this.state.gruposManual.filter((g) => g !== grupo),
    });
  }

  quitarDeGrupo(grupo, obj) {
    const complementos = grupo.complementos.filter((o) => o !== obj);
    this.setState({
      gruposManual: complementos.length
        ? this.state.gruposManual.map((g) => (g === grupo ? { ...g, complementos } : g))
        : this.state.gruposManual.filter((g) => g !== grupo),
    });
  }

  deshacerEmpateManual(mov) {
    this.setState({
      empatesManual: this.state.empatesManual.filter((p) => p.mov !== mov),
    });
  }

  // Parejas "casi iguales" entre lo que quedó sin empatar: mismo tipo, fecha dentro
  // de la ventana y una diferencia de centavos dentro del Ajuste Máx. Conciliación
  // de la empresa (p.ej. redondeos por tipo de cambio). Cada movimiento se usa una
  // sola vez; se prefiere la menor diferencia y luego la fecha más cercana.
  detectarSugerenciasCentavos() {
    if (!this.state.pdfResultado) return [];
    const tolerancia = this.toleranciaConciliacion();
    const { ventanaDias } = this.state;
    const sisLibres = this.cardsLibres("sis");
    const usados = new Set();
    const sugerencias = [];
    this.cardsLibres("pdf").forEach((mov) => {
      if (!mov.fecha) return;
      let mejor = null;
      sisLibres.forEach((ca) => {
        if (usados.has(ca)) return;
        if (!this.mismaNaturaleza({ tipo: "sis", obj: ca }, { tipo: "pdf", obj: mov })) return;
        const dif = round2Decimals(Math.abs(this.montoSis(ca) - this.montoPdf(mov)));
        if (dif === 0 || dif > tolerancia) return;
        const difDias = Math.abs(
          moment(ca.fechaRegistro).startOf("day").diff(moment(mov.fecha).startOf("day"), "days")
        );
        if (difDias > ventanaDias) return;
        if (!mejor || dif < mejor.dif || (dif === mejor.dif && difDias < mejor.difDias)) {
          mejor = { ca, mov, dif, difDias };
        }
      });
      if (mejor) {
        usados.add(mejor.ca);
        sugerencias.push(mejor);
      }
    });
    return sugerencias;
  }

  abrirModalCentavos() {
    const sugerencias = this.detectarSugerenciasCentavos();
    if (sugerencias.length === 0) return;
    this.setState({ modalCentavos: true, sugerenciasCentavos: sugerencias, seleccionCentavos: [] });
  }
  cerrarModalCentavos() {
    this.setState({ modalCentavos: false, seleccionCentavos: [] });
  }

  // Efecto con signo de las parejas sobre la diferencia final de la conciliación
  // (saldo inicial + cargos - abonos - saldo final): un depósito mayor en el sistema
  // la sube y un pago mayor la baja, así que pueden compensarse entre sí.
  netoCentavos(sugerencias) {
    return round2Decimals(
      sugerencias.reduce((total, s) => {
        const signo = s.ca.cargo != null ? 1 : -1;
        return total + (this.montoSis(s.ca) - this.montoPdf(s.mov)) * signo;
      }, 0)
    );
  }

  alternarSeleccionCentavos(sugerencia) {
    const seleccion = this.state.seleccionCentavos;
    this.setState({
      seleccionCentavos: seleccion.includes(sugerencia)
        ? seleccion.filter((s) => s !== sugerencia)
        : [...seleccion, sugerencia],
    });
  }

  // Pasa las parejas marcadas a "Relacionados manualmente" (con su DIF.). Se
  // persisten como cualquier empate manual, así al volver a cargar el PDF se
  // recuperan solas. Mismo candado que la relación N a 1: si el neto rebasa el
  // Ajuste Máx. Conciliación no se permite.
  confirmarSugerenciasCentavos() {
    const seleccion = this.state.seleccionCentavos;
    if (!seleccion.length) {
      message.info("Selecciona al menos una pareja");
      return;
    }
    const tolerancia = this.toleranciaConciliacion();
    const neto = this.netoCentavos(seleccion);
    if (Math.abs(neto) > tolerancia) {
      MensajeError({
        message: "No es posible conciliar estos movimientos",
        description: `La diferencia neta de las parejas seleccionadas es de: ${dineroDisabledMask(
          Math.abs(neto)
        )}.\nEl ajuste máximo de conciliación configurado es de: ${dineroDisabledMask(tolerancia)}.`,
      });
      return;
    }
    const estado = this.liberarCards(
      seleccion.flatMap((s) => [
        { tipo: "sis", obj: s.ca },
        { tipo: "pdf", obj: s.mov },
      ])
    );
    estado.empatesManual = [
      ...estado.empatesManual,
      ...seleccion.map((s) => ({ ca: s.ca, mov: s.mov, dif: s.dif })),
    ];
    this.setState({ ...estado, modalCentavos: false, sugerenciasCentavos: [], seleccionCentavos: [] });
    message.success(
      `${seleccion.length} pareja${seleccion.length > 1 ? "s" : ""} con diferencia de centavos ${
        seleccion.length > 1 ? "quedaron relacionadas" : "quedó relacionada"
      }. Usa "Conciliar Cuentas" para conciliarlas.`
    );
  }

  async aplicarEmpatePdf() {
    const { pdfResultado } = this.state;
    if (!pdfResultado) return;

    // Empatados automáticos + emparejados a mano, sin los ya conciliados.
    const aMarcar = this.movimientosPorConciliar();
    if (aMarcar.length === 0) {
      message.info("No hay movimientos nuevos que conciliar");
      return;
    }

    this.setState({ loading: true });
    // Una sola petición bulk (la misma del check masivo) con los ids a conciliar.
    let marcados = 0;
    try {
      const res = await axios.post(
        "conciliaciones/actualizarCargosAbonosConciliacionMasivo",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
          conciliar: true,
          cargosAbonosIds: aMarcar.map((ca) => ca._id),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const fallidos = new Set(
          (Array.isArray(res.data.fallidos) ? res.data.fallidos : []).map((f) => String(f.cargoAbonoId))
        );
        aMarcar.forEach((ca) => {
          if (fallidos.has(String(ca._id))) {
            message.warning(`No se pudo conciliar: ${ca.concepto}`);
          } else {
            marcados++;
            ca.conciliado = true; // marca el movimiento en el resultado visible (ya conciliado)
          }
        });
      } else if (res.data.success === 1) {
        message.error(res.data.message || "No se pudieron conciliar los movimientos");
      } else {
        message.error("Hubo un error y no se conciliaron los movimientos");
      }
    } catch (err) {
      message.error("Hubo un error y no se conciliaron los movimientos");
    }
    await this.consultarDatos(false);
    this.setState({ loading: false, pdfResultado: { ...this.state.pdfResultado } });
    if (marcados > 0) {
      message.success(
        `${marcados} movimiento(s) conciliados. Los movimientos del banco sin registrar siguen visibles para gestionarlos.`
      );
    }
  }

  descargarExcel() {
    const { cargosAbonos, saldoInicial, totalCargos, totalAbonos, saldoFinal } = this.state;

    const movimientos = cargosAbonos.map((ca) => ({
      Fecha: moment(ca.fechaRegistro).format("DD/MM/YYYY"),
      Concepto: ca.concepto,
      "Deposito (Cargo)": ca.cargo ?? "",
      "Pago (Abono)": ca.abono ?? "",
      Conciliado: ca.conciliado ? "Sí" : "No",
    }));

    const resumen = [
      {},
      { Fecha: "Saldo Inicial", "Deposito (Cargo)": saldoInicial },
      { Fecha: "Total Depósitos", "Deposito (Cargo)": totalCargos },
      { Fecha: "Total Pagos", "Pago (Abono)": totalAbonos },
      { Fecha: "Saldo Final Calculado", "Deposito (Cargo)": saldoInicial + totalCargos - totalAbonos },
      { Fecha: "Saldo Final", "Deposito (Cargo)": saldoFinal },
      { Fecha: "Diferencia", "Deposito (Cargo)": round2Decimals((saldoInicial + totalCargos - totalAbonos) - saldoFinal) },
    ];

    const worksheet = XLSX.utils.json_to_sheet([...movimientos, ...resumen]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Conciliación");
    XLSX.writeFile(workbook, `Conciliacion_${this.props.location.state.nombre}_${moment().format("YYYY-MM-DD")}.xlsx`);
  }
  datosConciliacionChange(values) {
    if(this.state.saldosCongelados){
      return;
    }
    if(values.saldoFinal !== null){
      axios.post(
        "conciliaciones/editarConciliacion",
        {
          ...values,
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success !== 2) {
          message.error("No se pudo editar la información de la conciliación");
        }else{
          this.consultarDatos()
        }
      })
    }
  }
  onChangeConciliacion(value, index){
    //Editar valor mientras se actualiza

    const nuevoArrayCargosAbonos = [...this.state.cargosAbonos]

    nuevoArrayCargosAbonos[index].conciliado = value

    this.setState({cargosAbonos: nuevoArrayCargosAbonos})

    const cargoAbono = this.state.cargosAbonos[index]
    if(value){
      axios.post(
        "conciliaciones/agregarCargoAbonoAConciliacion",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
          cargoAbonoId: cargoAbono._id
        },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success !== 2) {
          message.error("No se pudo agregar el movimiento a la conciliación");
        }else{
          this.consultarDatos(false)
        }
      })
    }else{
      axios.post(
        "conciliaciones/eliminarCargoAbonoAConciliacion",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
          cargoAbonoId: cargoAbono._id
        },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success !== 2) {
          message.error("No se pudo eliminar el movimiento a la conciliación");
        }else{
          this.consultarDatos(false)
        }
      })
    }
  }

  // Check global de la columna Conciliado: concilia todos los pendientes o quita
  // todas las conciliaciones, siempre tras confirmar en un modal. Va en una sola
  // petición bulk con los ids de los movimientos.
  // accion: "conciliar" | "quitar" (con el modal en "elegir" la manda el botón elegido).
  async aplicarConciliacionMasiva(accion = this.state.modalMasivo) {
    if (accion !== "conciliar" && accion !== "quitar") return;
    const conciliar = accion === "conciliar";
    const objetivo = this.state.cargosAbonos.filter((ca) => !!ca.conciliado !== conciliar);
    if (objetivo.length === 0) {
      this.setState({ modalMasivo: null });
      return;
    }
    this.setState({ aplicandoMasivo: true });
    try {
      const res = await axios.post(
        "conciliaciones/actualizarCargosAbonosConciliacionMasivo",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.props.location.state.id,
          conciliar,
          cargosAbonosIds: objetivo.map((ca) => ca._id),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const fallidos = Array.isArray(res.data.fallidos) ? res.data.fallidos.length : 0;
        const hechos = typeof res.data.actualizados === "number" ? res.data.actualizados : objetivo.length - fallidos;
        if (hechos > 0) {
          message.success(
            conciliar
              ? `${hechos} movimiento(s) conciliados`
              : `Se quitó la conciliación de ${hechos} movimiento(s)`
          );
        }
        if (fallidos > 0) message.warning(`${fallidos} movimiento(s) no se pudieron actualizar`);
      } else if (res.data.success === 1) {
        message.error(res.data.message || "No se pudieron actualizar los movimientos");
      } else {
        message.error("Hubo un error y no se actualizaron los movimientos");
      }
    } catch (err) {
      message.error("Hubo un error y no se actualizaron los movimientos");
    }
    await this.consultarDatos(false);
    this.setState({ aplicandoMasivo: false, modalMasivo: null });
  }

  renderModalMasivo() {
    const accion = this.state.modalMasivo;
    const elegir = accion === "elegir";
    const conciliar = accion === "conciliar";
    const pendientes = this.state.cargosAbonos.filter((ca) => !ca.conciliado).length;
    const conciliados = this.state.cargosAbonos.length - pendientes;
    const total = conciliar ? pendientes : conciliados;
    const s = (n) => (n === 1 ? "" : "s");
    return (
      <ModalItem
        title={
          elegir
            ? "Conciliación masiva"
            : conciliar
              ? "Conciliar todos los movimientos"
              : "Quitar todas las conciliaciones"
        }
        visible={!!accion}
        onCancel={() => !this.state.aplicandoMasivo && this.setState({ modalMasivo: null })}
        spinning={this.state.aplicandoMasivo}
        width={460}
        paddingTop
      >
        <p style={{ marginBottom: 0 }}>
          {elegir ? (
            <>
              Hay <b>{conciliados}</b> movimiento{s(conciliados)} conciliado{s(conciliados)} y <b>{pendientes}</b>{" "}
              pendiente{s(pendientes)}. ¿Qué quieres hacer con todos?
            </>
          ) : conciliar ? (
            <>¿Estás seguro de <b>conciliar</b> los <b>{total}</b> movimiento{s(total)} pendiente{s(total)}?</>
          ) : (
            <>¿Estás seguro de <b>quitar la conciliación</b> de los <b>{total}</b> movimiento{s(total)} conciliado{s(total)}?</>
          )}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 20,
            paddingTop: 12,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <ButtonItem
            danger
            lessTime
            disabled={this.state.aplicandoMasivo}
            onClick={() => this.setState({ modalMasivo: null })}
          >
            Cancelar
          </ButtonItem>
          {elegir ? (
            <>
              <ButtonItem
                blanco
                lessTime
                disabled={conciliados === 0 || this.state.aplicandoMasivo}
                onClick={() => this.aplicarConciliacionMasiva("quitar")}
              >
                Quitar todas ({conciliados})
              </ButtonItem>
              <ButtonItem
                type="primary"
                lessTime
                disabled={pendientes === 0 || this.state.aplicandoMasivo}
                onClick={() => this.aplicarConciliacionMasiva("conciliar")}
              >
                Conciliar pendientes ({pendientes})
              </ButtonItem>
            </>
          ) : (
            <ButtonItem
              type="primary"
              lessTime
              disabled={total === 0 || this.state.aplicandoMasivo}
              onClick={() => this.aplicarConciliacionMasiva()}
            >
              {conciliar ? "Conciliar todo" : "Quitar todo"}
            </ButtonItem>
          )}
        </div>
      </ModalItem>
    );
  }

  renderTarjetaMovimiento(datos) {
    if (!datos) {
      return (
        <div
          style={{
            border: "1px dashed #d9d9d9",
            borderRadius: 6,
            padding: "4px 10px",
            color: "#bfbfbf",
            fontSize: 11,
            textAlign: "center",
            background: "#fafafa",
            height: "100%",
          }}
        >
          Sin coincidencia
        </div>
      );
    }
    // Color SOLO en el monto (depósito/retiro) y en el borde exterior (acento).
    // El resto de la card es neutro para reducir ruido visual.
    const colorMonto = datos.esCargo ? "#389e0d" : "#d4380d";
    const invertido = !!datos.invertido;
    const direccion = invertido ? "row-reverse" : "row";
    const bordeAcento = `3px solid ${datos.acento || "#d9d9d9"}`;
    return (
      // El fondo (blanco, o azul tenue en hover/arrastre) vive en .tarjeta-mov (Styles.css).
      <div
        className="tarjeta-mov"
        style={{
          border: "1px solid #f0f0f0",
          [invertido ? "borderRight" : "borderLeft"]: bordeAcento,
          borderRadius: 6,
          padding: "4px 10px",
          height: "100%",
          lineHeight: 1.35,
        }}
      >
        {/* Dos columnas: texto (fecha + concepto completo, con salto de línea) y monto +
            tipo. El concepto nunca pasa por debajo del monto: queda separado por el gap. */}
        <div style={{ display: "flex", flexDirection: direccion, alignItems: "flex-start", gap: 40 }}>
          <div style={{ flex: 1, minWidth: 0, textAlign: invertido ? "right" : "left" }}>
            <div style={{ fontSize: 10, color: "#8c8c8c", whiteSpace: "nowrap" }}>{datos.fecha}</div>
            <div
              style={{
                fontSize: 7.8,
                lineHeight: 1.3,
                color: "#262626",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                textAlign: "justify",
                textAlignLast: invertido ? "right" : "left",
              }}
            >
              {datos.concepto || "—"}
            </div>
          </div>
          <div style={{ flexShrink: 0, textAlign: invertido ? "left" : "right" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: colorMonto, whiteSpace: "nowrap" }}>
              {dineroDisabledMask(datos.monto)}
            </div>
            <div style={{ fontSize: 9, textTransform: "uppercase", letterSpacing: "0.5px", color: "#bfbfbf", fontWeight: 600, whiteSpace: "nowrap" }}>
              {datos.conciliado && (
                <CheckCircleFilled title="Conciliado" style={{ color: "#389e0d", marginRight: 3 }} />
              )}
              {datos.tipoLabel}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Normaliza un cargoAbono del sistema a los datos que pinta la tarjeta.
  datosTarjetaSistema(ca) {
    const esCargo = ca.cargo != null;
    return {
      fecha: moment(ca.fechaRegistro).locale("es").format("ll"),
      concepto: ca.concepto,
      monto: esCargo ? ca.cargo : ca.abono,
      esCargo,
      tipoLabel: esCargo ? "Depósito" : "Pago",
      conciliado: this.conciliadoActual(ca),
    };
  }

  datosTarjetaPdf(mov) {
    return {
      fecha: mov.fecha ? moment(mov.fecha).locale("es").format("ll") : "—",
      // Descripción completa del banco (ordenante, beneficiario, rastreo...) si la
      // plantilla la arma; si no, el concepto corto.
      concepto: mov.detalle || mov.concepto,
      monto: mov.monto,
      esCargo: mov.tipo === "cargo",
      // Devolución = retiro con signo negativo en el PDF: dinero que regresó a la cuenta.
      tipoLabel: mov.esReverso
        ? "Depósito / Devolución"
        : mov.tipo === "cargo" ? "Depósito" : mov.tipo === "abono" ? "Retiro" : "Movimiento",
      invertido: true,
    };
  }

  renderParEmparejado(par, key, atenuado) {
    const acento = "#52c41a"; // emparejado = verde (estado relevante)
    return (
      <Row key={key} align="middle" gutter={8} style={{ opacity: atenuado ? 0.55 : 1 }}>
        <Col xs={9} sm={10}>
          <TarjetaDnD id={this.idCa(par.ca)} incompatible={this.cardNoRecibeDrag(this.idCa(par.ca))}>
            {this.renderTarjetaMovimiento({ ...this.datosTarjetaSistema(par.ca), acento })}
          </TarjetaDnD>
        </Col>
        <Col xs={6} sm={4} style={{ textAlign: "center", lineHeight: 1.2, marginBottom: 4 }}>
          <CheckCircleFilled style={{ color: acento, fontSize: 14 }} />
          {par.manual && (
            <>
              <div style={{ fontSize: 9, color: "#8c8c8c", fontWeight: 600 }}>MANUAL</div>
              {par.dif > 0 && (
                <div style={{ fontSize: 9, color: "#d48806", fontWeight: 600 }}>
                  DIF. {dineroDisabledMask(par.dif)}
                </div>
              )}
              {!this.conciliadoActual(par.ca) && (
                <span
                  onClick={() => this.deshacerEmpateManual(par.mov)}
                  style={{ fontSize: 10, color: "#8c8c8c", cursor: "pointer", textDecoration: "underline" }}
                >
                  deshacer
                </span>
              )}
            </>
          )}
        </Col>
        <Col xs={9} sm={10}>
          <TarjetaDnD id={this.idMov(par.mov)} incompatible={this.cardNoRecibeDrag(this.idMov(par.mov))}>
            {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(par.mov), acento })}
          </TarjetaDnD>
        </Col>
      </Row>
    );
  }

  renderGrupo(grupo, key) {
    const completo = this.grupoCompleto(grupo);
    const conciliado = this.casDeGrupo(grupo).every((ca) => this.conciliadoActual(ca));
    const acento = completo ? "#52c41a" : "#faad14";
    const tipoComp = this.tipoComplemento(grupo);
    const principalIzq = grupo.principal.tipo === "sis";
    const restante = this.restanteGrupo(grupo);
    const suma = this.sumaGrupo(grupo);

    const ladoPrincipal = (
      <TarjetaDnD id={this.idCard(grupo.principal)} incompatible={this.cardNoRecibeDrag(this.idCard(grupo.principal))}>
        {this.renderTarjetaMovimiento({ ...this.datosCard(grupo.principal), acento })}
      </TarjetaDnD>
    );

    const ladoComplementos = grupo.complementos.map((obj, idx) => {
      const card = { tipo: tipoComp, obj };
      return (
        <div key={`${key}-c-${idx}`}>
          <TarjetaDnD id={this.idCard(card)} incompatible={this.cardNoRecibeDrag(this.idCard(card))}>
            {this.renderTarjetaMovimiento({ ...this.datosCard(card), acento })}
          </TarjetaDnD>
          {!conciliado && grupo.complementos.length > 1 && (
            <div style={{ textAlign: "right", marginTop: -3, marginBottom: 4, lineHeight: 1.2 }}>
              <span
                onClick={() => this.quitarDeGrupo(grupo, obj)}
                style={{ fontSize: 10, color: "#8c8c8c", cursor: "pointer", textDecoration: "underline" }}
              >
                quitar
              </span>
            </div>
          )}
        </div>
      );
    });

    const centro = (
      <>
        {completo ? (
          <CheckCircleFilled style={{ color: acento, fontSize: 16 }} />
        ) : (
          <ExclamationCircleFilled style={{ color: acento, fontSize: 16 }} />
        )}
        <div style={{ fontSize: 9, color: "#8c8c8c", fontWeight: 600 }}>
          {grupo.complementos.length + 1} MOVIMIENTOS
        </div>
        <div style={{ fontSize: 10, color: "#595959", fontWeight: 600 }}>
          {dineroDisabledMask(suma)} / {dineroDisabledMask(this.montoCard(grupo.principal))}
        </div>
        {!completo && (
          <div style={{ fontSize: 10, color: "#d46b08", fontWeight: 700 }}>
            faltan {dineroDisabledMask(restante)}
          </div>
        )}
        {completo && restante !== 0 && (
          <div style={{ fontSize: 9, color: "#d48806", fontWeight: 600 }}>
            DIF. {dineroDisabledMask(Math.abs(restante))}
          </div>
        )}
        {!conciliado && (
          <span
            onClick={() => this.deshacerGrupo(grupo)}
            style={{ fontSize: 10, color: "#8c8c8c", cursor: "pointer", textDecoration: "underline" }}
          >
            deshacer
          </span>
        )}
      </>
    );

    return (
      <Row key={key} align="middle" gutter={8} style={{ marginBottom: 4, opacity: conciliado ? 0.55 : 1 }}>
        <Col xs={9} sm={10}>{principalIzq ? ladoPrincipal : ladoComplementos}</Col>
        <Col xs={6} sm={4} style={{ textAlign: "center", lineHeight: 1.2 }}>{centro}</Col>
        <Col xs={9} sm={10}>{principalIzq ? ladoComplementos : ladoPrincipal}</Col>
      </Row>
    );
  }

  // Una devolución del banco: el retiro y su devolución (misma clave de rastreo) con
  // las dos formas de tomarlos. movsConciliados = movimientos del PDF ya conciliados.
  renderParReverso(par, movsConciliados) {
    const clave = this.claveReverso(par);
    const separado = !this.state.reversosCancelados.includes(clave); // por defecto, por separado
    // Tomados por separado y ya conciliados: cancelarlos dejaría esa conciliación colgando.
    const bloqueado =
      separado && [par.original, par.devolucion].some((mov) => movsConciliados.includes(mov));
    const descripcion = { display: "block", fontSize: 11, color: "#8c8c8c" };
    return (
      <div
        key={clave}
        style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "10px 16px", marginBottom: 8, background: "#fff" }}
      >
        <Row gutter={[16, 8]} align="middle">
          <Col xs={24} md={14}>
            <div style={{ marginBottom: 4 }}>
              {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(par.original), invertido: false, acento: "#d9d9d9" })}
            </div>
            {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(par.devolucion), invertido: false, acento: "#d9d9d9" })}
            {par.devolucion.rastreo && (
              <div style={{ fontSize: 11, color: "#8c8c8c", marginTop: 4 }}>
                Clave de rastreo: {par.devolucion.rastreo}
              </div>
            )}
          </Col>
          <Col xs={24} md={10}>
            <Tooltip title={bloqueado ? "Ya está conciliado: quita esa conciliación para poder cancelarlo." : null}>
              <span>
                <Radio.Group
                  className="radio-devolucion-banco"
                  value={separado ? "separado" : "cancelado"}
                  disabled={this.state.saldosCongelados || bloqueado}
                  onChange={(e) => this.cambiarTratamientoReverso(par, e.target.value === "separado")}
                >
                  <Space direction="vertical" size={6}>
                    <Radio value="separado">
                      Tomarlos por separado
                      <span style={descripcion}>Un retiro y un depósito, para conciliarlos con el sistema</span>
                    </Radio>
                    <Radio value="cancelado">
                      Tomarlo como uno y cancelarlo
                      <span style={descripcion}>Se anulan entre sí (neto $0) y no afectan la conciliación</span>
                    </Radio>
                  </Space>
                </Radio.Group>
              </span>
            </Tooltip>
          </Col>
        </Row>
      </div>
    );
  }

  renderResultadoPdf(controlesCarga) {
    const { pdfResultado, empatesManual, gruposManual, autosRotos, dragId } = this.state;
    if (!pdfResultado) return null;

    const { empatados, noEmpatados, sobrantes } = pdfResultado;
    const porConciliar = this.movimientosPorConciliar().length;

    // Empates automáticos vivos vs rotos por D&D.
    const autoVivos = empatados.filter((e) => !autosRotos.includes(e.ca._id));
    const autoRotos = empatados.filter((e) => autosRotos.includes(e.ca._id));
    const manualCa = empatesManual.map((p) => p.ca);
    const manualMov = empatesManual.map((p) => p.mov);


    const grupoCa = [];
    const grupoMov = [];
    gruposManual.forEach((g) => {
      const destino = g.principal.tipo === "sis" ? grupoCa : grupoMov;
      destino.push(g.principal.obj);
      const destinoComp = this.tipoComplemento(g) === "sis" ? grupoCa : grupoMov;
      g.complementos.forEach((obj) => destinoComp.push(obj));
    });
    const gruposIncompletos = gruposManual.filter((g) => !this.grupoCompleto(g));
    const grupoConciliado = (g) => this.casDeGrupo(g).every((ca) => this.conciliadoActual(ca));
    const gruposConciliados = gruposManual.filter(grupoConciliado);
    const gruposPorConciliar = gruposManual.filter((g) => !grupoConciliado(g));

    const emparejados = [
      ...autoVivos.map((e) => ({ ca: e.ca, mov: e.mov, manual: false })),
      ...empatesManual.map((p) => ({ ca: p.ca, mov: p.mov, manual: true, dif: p.dif })),
    ];
    // "Esto ya lo hiciste" (conciliados, p.ej. al re-subir el PDF) vs "esto falta".
    const paresConciliados = emparejados.filter((p) => this.conciliadoActual(p.ca));
    const paresPorConciliar = emparejados.filter((p) => !this.conciliadoActual(p.ca));
    const autoPorConciliar = paresPorConciliar.filter((p) => !p.manual);
    const manualPorConciliar = paresPorConciliar.filter((p) => p.manual);

    // Pools de pendientes: no empatados + liberados de autos rotos, sin los ya
    // usados en un empate manual ni los ya conciliados.
    const sisPool = [...noEmpatados, ...autoRotos.map((e) => e.ca)].filter(
      (ca) => !this.conciliadoActual(ca) && !manualCa.includes(ca) && !grupoCa.includes(ca)
    );
    const pdfPool = [...sobrantes, ...autoRotos.map((e) => e.mov)].filter(
      (mov) => !manualMov.includes(mov) && !grupoMov.includes(mov)
    );

    // Posteriores a la fecha final: fuera del proceso principal (no son pendientes),
    // salvo los que el usuario ya relacionó a mano.
    const posteriores = (pdfResultado.posteriores || []).filter(
      (mov) => !manualMov.includes(mov) && !grupoMov.includes(mov)
    );
    const fechaFinalTexto = this.state.fechaFinal
      ? moment(this.state.fechaFinal).locale("es").format("ll")
      : "";

    const completo = porConciliar === 0 && pdfPool.length === 0 && gruposIncompletos.length === 0;
    const sugerenciasCentavos = this.detectarSugerenciasCentavos().length;

    // Card "fantasma" que sigue al cursor (cualquier tipo de card). Se pinta igual
    // que la original (los posteriores no van en espejo) para que coincida con ella.
    const dragResuelto = dragId ? this.resolverCardDnd(dragId) : null;
    const datosDrag =
      dragResuelto && dragResuelto.obj
        ? dragResuelto.tipo === "sis"
          ? this.datosTarjetaSistema(dragResuelto.obj)
          : {
              ...this.datosTarjetaPdf(dragResuelto.obj),
              invertido: !posteriores.includes(dragResuelto.obj),
            }
        : null;

    // Índice de secciones, con los mismos conteos que deciden si la sección se
    // pinta (count 0 = sección ausente = opción inactiva).
    const indice = [
      { clave: "sinConciliar", label: "Sin conciliar", n: sisPool.length + pdfPool.length },
      { clave: "conciliadosSistema", label: "Conciliados por el sistema", n: autoPorConciliar.length },
      { clave: "conciliadosManual", label: "Conciliados manualmente", n: manualPorConciliar.length + gruposPorConciliar.length },
      { clave: "yaConciliados", label: "Ya conciliados", n: paresConciliados.length + gruposConciliados.length },
      { clave: "fueraRango", label: "Fuera del rango del mes", n: posteriores.length },
      { clave: "devoluciones", label: "Devoluciones del banco", n: (pdfResultado.reversos || []).length },
    ];

    const movsConciliados = [
      ...paresConciliados.map((p) => p.mov),
      ...gruposConciliados.flatMap((g) =>
        g.principal.tipo === "pdf" ? [g.principal.obj] : g.complementos
      ),
    ];

    // Item del resumen: número con color de énfasis + etiqueta neutra.
    const stat = (n, label, color) => (
      <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
        <span style={{ fontSize: 16, fontWeight: 700, color }}>{n}</span>
        <span style={{ fontSize: 12, color: "#8c8c8c" }}>{label}</span>
      </div>
    );

    return (
      <DndContext
        sensors={SENSORES_DND}
        onDragStart={this.onDragStartEmpate}
        onDragEnd={this.onDragEndEmpate}
        onDragCancel={this.onDragCancelEmpate}
      >
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: -12, marginBottom: 48 }}>
            <div style={{ display: "flex", flexWrap: "wrap-reverse", alignItems: "center", gap: "12px 16px" }}>
            <div style={{ flex: "1 1 480px", minWidth: 0, boxShadow: "0 2px 8px rgba(145, 145, 145, 0.19)", background: "#fff", border: "1px solid #f0f0f0", borderRadius: 8, padding: "12px 16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px 24px", flexWrap: "wrap" }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>
                  Resumen de conciliación
                </div>
                <Space size={12} wrap split={<Divider type="vertical" style={{ margin: 0 }} />}>
                  {stat(paresPorConciliar.length, "por conciliar", "#389e0d")}
                  {paresConciliados.length > 0 && stat(paresConciliados.length, "ya conciliados", "#8c8c8c")}
                  {stat(pdfPool.length, "sin registrar (banco)", "#d4380d")}
                  {stat(sisPool.length, "sólo en sistema", "#8c8c8c")}
                  {gruposIncompletos.length > 0 &&
                    stat(gruposIncompletos.length, "agrupados sin completar", "#d46b08")}
                </Space>
                {completo && paresConciliados.length > 0 && (
                  <Tooltip title="Todo lo del PDF dentro del periodo está conciliado.">
                    <span style={{ fontSize: 12, fontWeight: 600, color: "#389e0d", whiteSpace: "nowrap" }}>
                      <CheckCircleFilled style={{ marginRight: 4 }} />
                      Conciliación completa
                    </span>
                  </Tooltip>
                )}
                <div style={{ marginLeft: "auto" }}>
                  {(() => {
                    const id = this.state.pdfPlantillaId;
                    const esGenerica = !id || id === "generica";
                    const nombre = (listaPlantillas().find((p) => p.id === id) || {}).nombre || "Genérica (auto)";
                    return esGenerica ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 14, height: 14, borderRadius: "50%", background: "transparent", border: "2px solid #fa541c" }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#ff6e3e", display: "inline-block" }} />
                        </span>
                      </span>
                    ) : (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 14, height: 14, borderRadius: "50%", background: "transparent", border: "2px solid #389e0d" }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#52c41a", display: "inline-block" }} />
                        </span>
                        <span style={{ fontSize: 12, fontWeight: 600, color: "#1a3a4a", whiteSpace: "nowrap" }}> Banco: {nombre}</span>
                      </span>
                    );
                  })()}
                </div>
              </div>

              {sugerenciasCentavos > 0 && (
                <div style={{ marginTop: 6, fontSize: 12, color: "#595959" }}>
                  <ExclamationCircleFilled style={{ color: "#faad14", marginRight: 6 }} />
                  {sugerenciasCentavos} posible{sugerenciasCentavos > 1 ? "s" : ""} coincidencia
                  {sugerenciasCentavos > 1 ? "s" : ""} con diferencia de centavos.{" "}
                  <span
                    onClick={() => this.abrirModalCentavos()}
                    style={{ color: "#00BFD6", cursor: "pointer", textDecoration: "underline", fontWeight: 600 }}
                  >
                    Revisar
                  </span>
                </div>
              )}
            </div>
            <div style={{ flex: "0 0 auto", marginLeft: "auto" }}>{controlesCarga}</div>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px 16px" }}>
            <div style={{ flex: "1 1 420px", minWidth: 0, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>
                Ir a
              </span>
              <div
                style={{ flex: 1, minWidth: 0, overflowX: "auto" }}
                onClick={(e) => {
                  if (e.target.tagName === "INPUT" && e.target.closest(".ant-segmented-item-selected")) {
                    this.irASeccion(this.state.seccionIndice);
                  }
                }}
              >
                <SegmentedItem
                  size="small"
                  className="segmented-indice-conciliacion"
                  value={this.state.seccionIndice}
                  onChange={(clave) => this.irASeccion(clave)}
                  options={indice.map((s) => ({ label: `${s.label} (${s.n})`, value: s.clave, disabled: s.n === 0 }))}
                />
              </div>
            </div>
            <div style={{ flex: "0 0 auto", marginLeft: "auto" }}>
              <ButtonItem
                type="primary"
                cyan
                disabled={porConciliar === 0 || this.state.saldosCongelados}
                onClick={this.aplicarEmpatePdf.bind(this)}
                style={{ fontSize: 14, fontWeight: 600, padding: "8px 24px", height: "auto" }}
              >
                Conciliar Cuentas
                {porConciliar > 0 && <span style={{ marginLeft: 8, fontWeight: 700 }}>({porConciliar})</span>}
              </ButtonItem>
            </div>
            </div>
          </div>

          {(sisPool.length > 0 || pdfPool.length > 0) &&
            this.renderSeccionPdf(
              "sinConciliar",
              {
                titulo: `Sin conciliar (${sisPool.length + pdfPool.length})`,
                detalle: `Sólo en sistema: ${sisPool.length} · Sin registrar (banco): ${pdfPool.length}`,
              },
              <>

                {pdfPool.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "flex-start",
                      background: "#fff",
                      border: "2px solid #fa1c1c5a",
                      borderRadius: 8,
                      padding: "15px 30px",
                      marginBottom: 16,
                    }}
                  >
                    <ExclamationCircleFilled style={{ color: "#fa1c1c", fontSize: 18, marginTop: 1, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontWeight: 700, color: "#262626", fontSize: 13, marginBottom: 2 }}>
                        {pdfPool.length} movimiento{pdfPool.length > 1 ? "s" : ""} del banco no {pdfPool.length > 1 ? "están" : "está"} en la sección "Movimientos" del sistema.
                      </div>
                      <div style={{ fontSize: 12.0, color: "#8c8c8cd5"}}>             
                         <ul>
                          <li>
                            <b style={{ color: "#595959" }}>
                              Debes registrarlos o actualizarlos en el sistema.
                            </b>
                          </li>
                          <li>
                            <b style={{ color: "#595959" }}>
                              Si alguno ya existe en el sistema, arrástralo hacia su movimiento correspondiente para conciliarlo manualmente.
                            </b>
                          </li>
                        </ul>             
                      </div>
                    </div>
                  </div>
                )}

                <Row gutter={8} style={{ marginBottom: 6 }}>
                  <Col xs={9} sm={10}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8c8c8c" }}>Sólo en Sistema</div>
                  </Col>
                  <Col xs={6} sm={4} />
                  <Col xs={9} sm={10} style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#d4380d" }}>Sin registrar (banco)</div>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={9} sm={10}>
                    {sisPool.map((ca) => (
                      <TarjetaDnD key={this.idCa(ca)} id={this.idCa(ca)} incompatible={this.cardNoRecibeDrag(this.idCa(ca))}>
                        {this.renderTarjetaMovimiento({ ...this.datosTarjetaSistema(ca), acento: "#d9d9d9" })}
                      </TarjetaDnD>
                    ))}
                    {sisPool.length === 0 && (
                      <div style={{ fontSize: 12, color: "#bfbfbf", textAlign: "center", padding: 12 }}>Sin pendientes del sistema</div>
                    )}
                  </Col>
                  <Col xs={6} sm={4} style={{ textAlign: "center" }}>
                    <div style={{ color: "#d9d9d9", fontSize: 18, marginTop: 6 }}>⇄</div>
                  </Col>
                  <Col xs={9} sm={10}>
                    {pdfPool.map((mov) => (
                      <TarjetaDnD key={this.idMov(mov)} id={this.idMov(mov)} incompatible={this.cardNoRecibeDrag(this.idMov(mov))}>
                        {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(mov), acento: "#FF6A0D" })}
                      </TarjetaDnD>
                    ))}
                    {pdfPool.length === 0 && (
                      <div style={{ fontSize: 12, color: "#389e0d", textAlign: "center", padding: 12, fontWeight: 600 }}>
                        <CheckCircleFilled /> Todo el banco está registrado
                      </div>
                    )}
                  </Col>
                </Row>
              </>
            )}

          {(autoPorConciliar.length > 0 ||
            manualPorConciliar.length > 0 ||
            gruposPorConciliar.length > 0 ||
            paresConciliados.length > 0 ||
            gruposConciliados.length > 0) && (
            <>
              <Divider style={{ margin: "24px 0 12px" }} />

              <Row gutter={8} align="middle" style={{ marginBottom: 12, padding: "0 17px" }}>
                <Col xs={9} sm={10}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#006b7a" }}>Movimientos del Sistema</div>
                </Col>
                <Col xs={6} sm={4} style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 11, fontWeight: 500, color: "#bfbfbf", textTransform: "uppercase" }}>Estado</div>
                </Col>
                <Col xs={9} sm={10} style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#006b7a" }}>Movimientos del PDF Bancario</div>
                </Col>
              </Row>

              {autoPorConciliar.length > 0 &&
                this.renderSeccionPdf(
                  "conciliadosSistema",
                  { titulo: `Detectados por el sistema (${autoPorConciliar.length})` },
                  autoPorConciliar.map((par, idx) => this.renderParEmparejado(par, `a-${idx}`, false))
                )}
              {(manualPorConciliar.length > 0 || gruposPorConciliar.length > 0) &&
                this.renderSeccionPdf(
                  "conciliadosManual",
                  {
                    titulo: (
                      <>
                        Relacionados manualmente ({manualPorConciliar.length + gruposPorConciliar.length})
                        {gruposIncompletos.length > 0 && (
                          <span style={{ color: "#d46b08", fontWeight: 500 }}>
                            {" "}— falta completar {gruposIncompletos.length}
                          </span>
                        )}
                      </>
                    ),
                  },
                  <>
                    {manualPorConciliar.map((par, idx) => this.renderParEmparejado(par, `m-${idx}`, false))}
                    {gruposPorConciliar.map((grupo, idx) => this.renderGrupo(grupo, `g-${idx}`))}
                  </>
                )}
              {paresConciliados.length + gruposConciliados.length > 0 &&
                this.renderSeccionPdf(
                  "yaConciliados",
                  { titulo: `Ya conciliados (${paresConciliados.length + gruposConciliados.length})` },
                  <>
                    {paresConciliados.map((par, idx) => this.renderParEmparejado(par, `c-${idx}`, true))}
                    {gruposConciliados.map((grupo, idx) => this.renderGrupo(grupo, `gc-${idx}`))}
                  </>
                )}
            </>
          )}

          {posteriores.length > 0 &&
            this.renderSeccionPdf(
              "fueraRango",
              {
                titulo: `Movimientos posteriores a la fecha final (${posteriores.length})`,
                detalle: `Después del ${fechaFinalTexto}: no cuentan para esta conciliación`,
                style: { marginTop: 24 },
              },
              <>
                <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 10 }}>
                  Si alguno sí corresponde a esta conciliación, dale clic para elegir su movimiento del sistema.
                  Los que dejes aquí no afectan el resultado ni impiden guardar la conciliación.
                </div>

                <div
                  className="tablero-scroll-x"
                  style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    gridTemplateRows: `repeat(${Math.min(3, posteriores.length)}, auto)`,
                    gridAutoColumns: "minmax(260px, 300px)",
                    columnGap: 10,
                    overflowX: "auto",
                    paddingBottom: 6,
                  }}
                >
                  {posteriores.map((mov) => (
                    <TarjetaDnD key={this.idMov(mov)} id={this.idMov(mov)} incompatible={this.cardNoRecibeDrag(this.idMov(mov))}>
                      <Tooltip title="Clic para conciliarlo con un movimiento del sistema" placement="top" mouseEnterDelay={0.6}>
                        <div onClick={() => this.abrirModalPosterior(mov)}>
                          {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(mov), invertido: false, acento: "#bfbfbf" })}
                        </div>
                      </Tooltip>
                    </TarjetaDnD>
                  ))}
                </div>
              </>
            )}

          {(pdfResultado.reversos || []).length > 0 &&
            this.renderSeccionPdf(
              "devoluciones",
              {
                titulo: `Devoluciones del banco (${pdfResultado.reversos.length})`,
                detalle: "Retiros que el banco regresó a la cuenta",
                style: { marginTop: 24 },
              },
              pdfResultado.reversos.map((par) => this.renderParReverso(par, movsConciliados))
            )}
          {this.renderBarraSeccionFija()}
        </div>
        {createPortal(
          <DragOverlay dropAnimation={null}>
            {datosDrag ? (
              <div className="tarjeta-dnd-overlay" style={{ width: "100%", borderRadius: 6, boxShadow: "0 6px 16px rgba(0, 0, 0, 0.18)" }}>
                {this.renderTarjetaMovimiento({ ...datosDrag, acento: "#00BFD6" })}
              </div>
            ) : null}
          </DragOverlay>,
          document.body
        )}
      </DndContext>
    );
  }
  renderListaSeleccionGrupo(datos) {
    const { seleccionGrupo, busquedaGrupo } = this.state;
    const tipoComp = datos.principal.tipo === "sis" ? "pdf" : "sis";
    const montoPrincipal = this.montoCard(datos.principal);

    const etiquetaPrincipal = this.etiquetaCard(datos.principal);

    const libres = this.cardsLibres(tipoComp).filter((obj) =>
      this.mismaNaturaleza(datos.principal, { tipo: tipoComp, obj })
    );
    const disponibles = [...libres];
    seleccionGrupo.forEach((obj) => {
      if (!disponibles.includes(obj)) disponibles.push(obj);
    });

    const termino = busquedaGrupo.replace(/[$,\s]/g, "");
    const visibles = termino
      ? disponibles.filter((obj) =>
          String(this.montoCard({ tipo: tipoComp, obj })).includes(termino)
        )
      : disponibles;

    const suma = round2Decimals(
      seleccionGrupo.reduce((total, obj) => total + this.montoCard({ tipo: tipoComp, obj }), 0)
    );
    const restante = round2Decimals(montoPrincipal - suma);
    const cuadra = Math.abs(restante) <= this.toleranciaConciliacion();
    const permiteSeleccionMasiva = termino.length > 0 && visibles.length > 1;
    const visiblesMarcados = visibles.filter((obj) => seleccionGrupo.includes(obj));
    const todosVisiblesMarcados =
      visibles.length > 0 && visiblesMarcados.length === visibles.length;

    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            border: "1px solid #f0f0f0",
            borderRadius: 8,
            padding: "8px 12px",
            marginBottom: 12,
          }}
        >
          <span style={{ fontSize: 13, color: "#8c8c8c" }}>
            Movimiento principal ({datos.principal.tipo === "sis" ? "sistema" : "banco"}) ·{" "}
            <b style={{ color: "#595959", textTransform: "capitalize" }}>{etiquetaPrincipal}</b>
          </span>
          <span style={{ fontSize: 16, fontWeight: 700 }}>{dineroDisabledMask(montoPrincipal)}</span>
        </div>

        <Input
          allowClear
          placeholder="Buscar por monto ($)"
          value={busquedaGrupo}
          onChange={(e) => this.setState({ busquedaGrupo: e.target.value })}
          style={{ marginBottom: 6 }}
        />

        <div style={{ fontSize: 11, color: "#8c8c8c", marginBottom: permiteSeleccionMasiva ? 6 : 10 }}>
          Sólo se listan movimientos del mismo tipo ({etiquetaPrincipal}s): no se pueden mezclar
          depósitos con retiros.
        </div>

        {permiteSeleccionMasiva && (
          <div style={{ fontSize: 11, color: "#8c8c8c", marginBottom: 10 }}>
            {visibles.length} movimientos coinciden con ese monto: usa el check del encabezado
            para seleccionarlos todos.
          </div>
        )}

        <div style={{ maxHeight: "40vh", overflowY: "auto", border: "1px solid #f0f0f0", borderRadius: 8 }}>
          <table className="table table-12px" style={{ width: "100%", backgroundColor: "white" }}>
            <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
              <tr>
                <th className="th-border" style={{ width: "15%", textAlign: "center" }}>
                  {permiteSeleccionMasiva && (
                    <Tooltip title={`Seleccionar los ${visibles.length} movimientos de este monto`}>
                      <Checkbox
                        checked={todosVisiblesMarcados}
                        indeterminate={visiblesMarcados.length > 0 && !todosVisiblesMarcados}
                        onChange={(e) => this.alternarSeleccionVisibles(visibles, e.target.checked)}
                      />
                    </Tooltip>
                  )}
                </th>
                <th className="th-border" style={{ width: "45%" }}>Fecha</th>
                <th className="th-border" style={{ width: "40%", textAlign: "right" }}>Monto</th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((obj, idx) => {
                const card = { tipo: tipoComp, obj };
                const d = this.datosCard(card);
                const marcado = seleccionGrupo.includes(obj);
                return (
                  <tr
                    key={idx.toString()}
                    className="fila-insumo"
                    onClick={() => this.alternarSeleccionGrupo(obj)}
                    style={{ background: marcado ? "rgba(0,191,214,0.06)" : undefined }}
                  >
                    <td className="td-border-center">
                      <Checkbox checked={marcado} onChange={() => this.alternarSeleccionGrupo(obj)} />
                    </td>
                    <td className="td-border">
                      <p style={{ marginBottom: 0 }}>{d.fecha}</p>
                    </td>
                    <td className="td-border-right">
                      <p style={{ marginBottom: 0, textAlign: "right", fontWeight: 600 }}>
                        {dineroDisabledMask(d.monto)}
                      </p>
                    </td>
                  </tr>
                );
              })}
              {visibles.length === 0 && (
                <tr>
                  <td className="td-border" colSpan={3}>
                    <p style={{ marginBottom: 0, textAlign: "center", color: "#bfbfbf" }}>
                      No hay {etiquetaPrincipal}s disponibles para relacionar
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginTop: 12,
            padding: "8px 12px",
            borderRadius: 8,
            background: cuadra ? "rgba(82,196,26,0.10)" : "rgba(255,77,79,0.08)",
          }}
        >
          <span style={{ fontSize: 13, color: "#595959" }}>
            {seleccionGrupo.length} seleccionado{seleccionGrupo.length === 1 ? "" : "s"}:{" "}
            <b>{dineroDisabledMask(suma)}</b>
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: cuadra ? "#389e0d" : "#d4380d" }}>
            {cuadra
              ? "Cuadra"
              : restante > 0
                ? `Faltan ${dineroDisabledMask(restante)}`
                : `Se pasa por ${dineroDisabledMask(Math.abs(restante))}`}
          </span>
        </div>
      </>
    );
  }

  // Modal que aparece al cargar el PDF con las parejas que sólo difieren por
  // centavos. Inician desmarcadas: el usuario elige una por una o todas.
  abrirModalPosterior(mov) {
    this.setState({ modalPosterior: mov, seleccionPosterior: null, busquedaPosterior: "" });
  }
  cerrarModalPosterior() {
    this.setState({ modalPosterior: null, seleccionPosterior: null });
  }

  // Usa el mismo camino que el arrastre (intentarEmparejar), así hereda todas las
  // reglas: empate directo, margen de centavos, grupo N a 1 y movimientos ya conciliados.
  confirmarModalPosterior() {
    const { modalPosterior: mov, seleccionPosterior: ca } = this.state;
    if (!mov || !ca) {
      message.info("Selecciona un movimiento del sistema");
      return;
    }
    this.setState({ modalPosterior: null, seleccionPosterior: null }, () => this.intentarEmparejar(ca, mov));
  }

  // Selector para un movimiento del banco posterior a la fecha final. Sólo lista
  // movimientos del sistema libres (sin conciliar, sin pareja ni grupo) y del mismo
  // tipo, del monto más parecido al menos parecido.
  renderModalPosterior() {
    const { modalPosterior: mov, seleccionPosterior, busquedaPosterior } = this.state;
    const tolerancia = this.toleranciaConciliacion();
    let candidatos = [];
    let etiqueta = "movimiento";
    if (mov) {
      const montoMov = this.montoPdf(mov);
      etiqueta = this.etiquetaCard({ tipo: "pdf", obj: mov });
      candidatos = this.cardsLibres("sis")
        .filter((ca) => this.mismaNaturaleza({ tipo: "sis", obj: ca }, { tipo: "pdf", obj: mov }))
        .map((ca) => ({
          ca,
          dif: round2Decimals(Math.abs(this.montoSis(ca) - montoMov)),
          difDias: mov.fecha
            ? Math.abs(moment(ca.fechaRegistro).startOf("day").diff(moment(mov.fecha).startOf("day"), "days"))
            : 0,
        }))
        .sort((a, b) => a.dif - b.dif || a.difDias - b.difDias);
      const termino = busquedaPosterior.replace(/[$,\s]/g, "");
      if (termino) {
        candidatos = candidatos.filter((c) => String(this.montoSis(c.ca)).includes(termino));
      }
    }

    return (
      <ModalItem
        title="Conciliar movimiento posterior a la fecha final"
        visible={!!mov}
        onCancel={this.cerrarModalPosterior.bind(this)}
        spinning={false}
        width={640}
        paddingTop
      >
        {mov && (
          <>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#8c8c8c", marginBottom: 4 }}>Movimiento del banco</div>
            <div style={{ marginBottom: 14 }}>
              {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(mov), invertido: false, acento: "#FF6A0D" })}
            </div>

            <Input
              allowClear
              placeholder="Buscar por monto ($)"
              value={busquedaPosterior}
              onChange={(e) => this.setState({ busquedaPosterior: e.target.value })}
              style={{ marginBottom: 6 }}
            />
            <div style={{ fontSize: 11, color: "#8c8c8c", marginBottom: 10 }}>
              Sólo se listan {etiqueta}s del sistema que aún no están conciliados ni relacionados.
            </div>

            <div style={{ maxHeight: "40vh", overflowY: "auto", border: "1px solid #f0f0f0", borderRadius: 8 }}>
              <table className="table table-12px" style={{ width: "100%", backgroundColor: "white" }}>
                <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
                  <tr>
                    <th className="th-border" style={{ width: "8%" }} />
                    <th className="th-border" style={{ width: "20%" }}>Fecha</th>
                    <th className="th-border" style={{ width: "44%" }}>Concepto</th>
                    <th className="th-border" style={{ width: "28%", textAlign: "right" }}>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  {candidatos.map(({ ca, dif }) => {
                    const d = this.datosTarjetaSistema(ca);
                    const marcado = seleccionPosterior === ca;
                    const colorDif = dif === 0 ? "#389e0d" : dif <= tolerancia ? "#d48806" : "#8c8c8c";
                    return (
                      <tr
                        key={ca._id}
                        className="fila-insumo"
                        onClick={() => this.setState({ seleccionPosterior: ca })}
                        style={{ background: marcado ? "rgba(0,191,214,0.08)" : undefined }}
                      >
                        <td className="td-border-center">
                          <Checkbox checked={marcado} />
                        </td>
                        <td className="td-border">
                          <p style={{ marginBottom: 0 }}>{d.fecha}</p>
                        </td>
                        <td className="td-border">
                          <p style={{ marginBottom: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240 }} title={d.concepto}>
                            {d.concepto || "—"}
                          </p>
                        </td>
                        <td className="td-border-right">
                          <p style={{ marginBottom: 0, textAlign: "right", fontWeight: 600 }}>
                            {dineroDisabledMask(d.monto)}
                          </p>
                          <p style={{ marginBottom: 0, textAlign: "right", fontSize: 10, fontWeight: 600, color: colorDif }}>
                            {dif === 0 ? "Mismo monto" : `Dif. ${dineroDisabledMask(dif)}`}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                  {candidatos.length === 0 && (
                    <tr>
                      <td className="td-border" colSpan={4}>
                        <p style={{ marginBottom: 0, textAlign: "center", color: "#bfbfbf" }}>
                          No hay {etiqueta}s del sistema disponibles. Si este movimiento no está registrado,
                          regístralo en la sección "Movimientos".
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 20,
                paddingTop: 12,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              <ButtonItem danger lessTime onClick={this.cerrarModalPosterior.bind(this)}>
                Cancelar
              </ButtonItem>
              <ButtonItem
                type="primary"
                lessTime
                disabled={!seleccionPosterior}
                onClick={this.confirmarModalPosterior.bind(this)}
              >
                Conciliar
              </ButtonItem>
            </div>
          </>
        )}
      </ModalItem>
    );
  }

  renderModalCentavos() {
    const { sugerenciasCentavos: sugerencias, seleccionCentavos: seleccion } = this.state;
    const tolerancia = this.toleranciaConciliacion();
    const todas =sugerencias.length > 0 && seleccion.length === sugerencias.length;

    return (
      <ModalItem
        title="Coincidencias con diferencia de centavos"
        visible={this.state.modalCentavos}
        onCancel={this.cerrarModalCentavos.bind(this)}
        spinning={false}
        width={760}
        paddingTop
      >
        <p style={{ marginBottom: 12 }}>
          Estos movimientos del sistema y del banco son del mismo tipo y fecha, pero difieren por
          centavos dentro de tu <b>Ajuste Máx. Conciliación ({dineroDisabledMask(tolerancia)})</b>.
          Marca las parejas que sí correspondan para dejarlas listas para conciliar.
        </p>

        <Row gutter={8} align="middle" style={{ marginBottom: 6, padding: "0 6px" }}>
          <Col span={10}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#006b7a" }}>Sistema</div>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Checkbox
              checked={todas}
              indeterminate={seleccion.length > 0 && !todas}
              onChange={(e) =>
                this.setState({ seleccionCentavos: e.target.checked ? [...sugerencias] : [] })
              }
            >
              <span style={{ fontSize: 11, color: "#8c8c8c" }}>Todas</span>
            </Checkbox>
          </Col>
          <Col span={10} style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#006b7a" }}>Banco</div>
          </Col>
        </Row>

        <div style={{ maxHeight: "50vh", overflowY: "auto", overflowX: "hidden", border: "1px solid #f0f0f0", borderRadius: 8, padding: 6 }}>
          {sugerencias.map((s, idx) => {
            const marcado = seleccion.includes(s);
            return (
              <Row
                key={idx.toString()}
                gutter={8}
                align="middle"
                onClick={() => this.alternarSeleccionCentavos(s)}
                style={{
                  cursor: "pointer",
                  borderRadius: 6,
                  padding: "2px 0",
                  marginBottom: 4,
                  background: marcado ? "rgba(0,191,214,0.08)" : undefined,
                }}
              >
                <Col span={10}>
                  {this.renderTarjetaMovimiento({ ...this.datosTarjetaSistema(s.ca), acento: "#d9d9d9" })}
                </Col>
                <Col span={4} style={{ textAlign: "center", lineHeight: 1.2 }}>
                  <span onClick={(e) => e.stopPropagation()}>
                    <Checkbox checked={marcado} onChange={() => this.alternarSeleccionCentavos(s)} />
                  </span>
                  <div style={{ fontSize: 9, color: "#d48806", fontWeight: 600, marginTop: 2 }}>
                    DIF. {dineroDisabledMask(s.dif)}
                  </div>
                </Col>
                <Col span={10}>
                  {this.renderTarjetaMovimiento({ ...this.datosTarjetaPdf(s.mov), acento: "#FF6A0D" })}
                </Col>
              </Row>
            );
          })}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 20,
            paddingTop: 12,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <ButtonItem danger lessTime onClick={this.cerrarModalCentavos.bind(this)}>
            Ahora no
          </ButtonItem>
          <ButtonItem
            type="primary"
            lessTime
            disabled={seleccion.length === 0}
            onClick={this.confirmarSugerenciasCentavos.bind(this)}
          >
            Relacionar seleccionadas{seleccion.length > 0 ? ` (${seleccion.length})` : ""}
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }

  renderModalEmpate() {
    const datos = this.state.modalEmpate;
    const tolerancia = this.toleranciaConciliacion();
    const esTolerancia = !datos || datos.modo === "tolerancia";
    const paso2 = !!datos && datos.paso === 2;

    const fila = (label, valor, color) => (
      <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
        <span style={{ fontSize: 13, color: "#8c8c8c" }}>{label}</span>
        <span style={{ fontSize: 14, fontWeight: 700, color: color || "#262626" }}>{valor}</span>
      </div>
    );

    const titulo = esTolerancia
      ? "Diferencia dentro del margen"
      : paso2
        ? "Selecciona los movimientos a relacionar"
        : "Relacionar varios movimientos";

    return (
      <ModalItem
        title={titulo}
        visible={this.state.modalEmpateVisible}
        onCancel={this.cerrarModalEmpate.bind(this)}
        spinning={false}
        width={paso2 ? 560 : 480}
        paddingTop
      >
        {datos && (
          <>
            {paso2 ? (
              this.renderListaSeleccionGrupo(datos)
            ) : (
              <>
                <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "4px 12px", marginBottom: 14 }}>
                  {fila("Movimiento del sistema", dineroDisabledMask(this.montoSis(datos.ca)))}
                  <Divider style={{ margin: 0 }} />
                  {fila("Movimiento del banco", dineroDisabledMask(this.montoPdf(datos.mov)))}
                  <Divider style={{ margin: 0 }} />
                  {fila("Diferencia", dineroDisabledMask(datos.dif), esTolerancia ? "#d48806" : "#d4380d")}
                </div>

                {esTolerancia ? (
                  <p style={{ marginBottom: 0 }}>
                    La diferencia se encuentra dentro del margen de tolerancia configurado para la empresa
                    (<b>{dineroDisabledMask(tolerancia)}</b>). ¿Deseas continuar con la conciliación?
                  </p>
                ) : (
                  <>
                    <p style={{ marginBottom: 8, fontWeight: 600 }}>
                      ¿Deseas relacionar este movimiento con otros movimientos adicionales?
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      Este movimiento puede quedar asociado a uno o más movimientos para completar la
                      conciliación.
                    </p>
                  </>
                )}
              </>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 20,
                paddingTop: 12,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              <ButtonItem danger lessTime onClick={this.cerrarModalEmpate.bind(this)}>
                Cancelar
              </ButtonItem>
              <ButtonItem type="primary" lessTime onClick={this.confirmarModalEmpate.bind(this)}>
                {esTolerancia ? "Conciliar" : paso2 ? "Relacionar" : "Continuar"}
              </ButtonItem>
            </div>
          </>
        )}
      </ModalItem>
    );
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const saldoFinalCalculado = this.state.saldoInicial + this.state.totalCargos - this.state.totalAbonos;
    const diferencia = round2Decimals(saldoFinalCalculado - this.state.saldoFinal);
    const conciliadoOk = diferencia === 0;
    const toleranciaAjuste = typeof this.state.ajusteMaxConciliacion === "number" ? this.state.ajusteMaxConciliacion : 0.5;
    const mostrarBotonAjuste = diferencia !== 0 && Math.abs(diferencia) <= toleranciaAjuste;
    const sufijoMonedaAjuste = !this.esMXN(this.state.monedaBanco) ? ` ${this.state.monedaBanco.abreviacion}` : "";

    // Tile reutilizable del resumen de saldos
    const statTile = (label, value, { color = "#1a3a4a", bg = "#fff", border = "#e8e8e8" } = {}) => (
      <div
        style={{
          background: bg,
          border: `1px solid ${border}`,
          borderRadius: 8,
          padding: isMobile ? "8px 6px" : "12px 10px",
          textAlign: "center",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div style={{ fontSize: isMobile ? 14 : 20, fontWeight: 700, color, lineHeight: 1.2, wordBreak: "break-word" }}>
          {value}
        </div>
        <div style={{ fontSize: 11, color: "#8c8c8c", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600 }}>
          {label}
        </div>
      </div>
    );

    const operador = (simbolo) => (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: isMobile ? 16 : 24, fontWeight: 700, color: "#00BFD6" }}>
        {simbolo}
      </div>
    );

    // Carga del PDF + ventana de días. Con PDF cargado van a la derecha del resumen;
    // sin PDF, en la esquina superior derecha junto a la explicación.
    const controlesCargaPdf = (
      <>
        <Space size={[12, 8]} wrap align="center">
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "#8c8c8c" }}>
            Coincidencia de fecha:
            <Tooltip title="Margen de días permitido entre la fecha del movimiento en el banco y la registrada en el sistema para considerarlos el mismo. Por defecto exige la misma fecha.">
              <QuestionCircleOutlined style={{ color: "#bfbfbf", cursor: "help" }} />
            </Tooltip>
            <Select
              size="small"
              value={this.state.ventanaDias}
              onChange={(v) => this.cambiarVentanaDias(v)}
              style={{ width: 130 }}
              options={[
                { value: 0, label: "Misma fecha" },
                { value: 1, label: "± 1 día" },
                { value: 2, label: "± 2 días" },
                { value: 3, label: "± 3 días" },
                { value: 4, label: "± 4 días" },
                { value: 5, label: "± 5 días" },
              ]}
            />
          </span>

          <ButtonItem
            icon={<UploadOutlined />}
            blanco
            disabled={this.state.saldosCongelados}
            onClick={() => this.pdfInputRef.current?.click()}
            className="cartaPunteada"
          >
            Cargar PDF del Banco
          </ButtonItem>
        </Space>

        <input
          type="file"
          ref={this.pdfInputRef}
          accept=".pdf"
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];
            e.target.value = "";
            if (file) this.leerPdfBanco(file);
          }}
        />
      </>
    );

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Conciliación: " + this.props.location.state.nombre}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {/* <Upload
                accept=".xlsx"
                showUploadList={false}
                customRequest={({ file, onSuccess }) => {
                  this.subirExcel(file);
                  onSuccess("ok");
                }}
              >
                <ButtonItem blanco icon={<UploadOutlined />}>
                  Subir Excel
                </ButtonItem>
              </Upload> */}
              <ButtonItem
                blanco
                icon={<FileExcelOutlined />}
                onClick={this.descargarExcel.bind(this)}
              >
                Descargar Excel
              </ButtonItem>
            </Space>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            {this.state.saldosCongelados && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
                message="Conciliación reabierta"
                description="Los saldos inicial y final, la referencia y las fechas quedaron fijos. Sólo puedes marcar o desmarcar cargos y abonos."
              />
            )}

            <Row gutter={[16, 16]}>

              <DynamicCardForm title="Datos de la Conciliación" xs={24} sm={24} lg={8} xl={8} noMargin>
                <Form
                  ref={this.formRefDatosConciliacion}
                  name="datosConciliacion"
                  layout
                  onValuesChange={this.datosConciliacionChange.bind(this)}
                >
                  <FormItem
                    label="Saldo Final"
                    name="saldoFinal"
                    required
                    margin
                    numberCero
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <InputNumberItem disabled={this.state.saldosCongelados} placeholder="saldoFinal" dinero />
                  </FormItem>
                  <FormItem
                    name="referencia"
                    label="Referencia"
                    margin
                    pattern
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <InputItem disabled={this.state.saldosCongelados} placeholder="Referencia" />
                  </FormItem>
                  <FormItem margin label="Fecha Inicial" name="fechaInicial" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <DatePickerItem disabled={this.state.saldosCongelados} />
                  </FormItem>
                  <FormItem margin label="Fecha Final" name="fechaFinal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <DatePickerItem disabled={this.state.saldosCongelados} />
                  </FormItem>
                </Form>
              </DynamicCardForm>

              <DynamicCardForm
                title="Resumen de Saldos"
                xs={24}
                sm={24}
                lg={16}
                xl={16}
                noMargin
              >
                <Row gutter={[8, 8]} align="stretch">
                  <Col span={5} xs={7} sm={5}>{statTile("Saldo Inicial", dineroDisabledMask(this.state.saldoInicial))}</Col>
                  <Col span={1} xs={1} sm={1}>{operador("+")}</Col>
                  <Col span={5} xs={7} sm={5}>{statTile("Depósitos", dineroDisabledMask(this.state.totalCargos), { color: "#52c41a" })}</Col>
                  <Col span={1} xs={1} sm={1}>{operador("−")}</Col>
                  <Col span={5} xs={7} sm={5}>{statTile("Pagos", dineroDisabledMask(this.state.totalAbonos), { color: "#ff6a0d" })}</Col>
                  <Col span={1} xs={1} sm={1}>{operador("=")}</Col>
                  <Col span={6} xs={24} sm={6}>{statTile("Saldo Final Calc.", dineroDisabledMask(saldoFinalCalculado), { bg: "rgba(0,191,214,0.08)", border: "#00BFD6", color: "#00838f" })}</Col>
                </Row>

                <Row gutter={[8, 8]} style={{ marginTop: 12 }} align="stretch">
                  <Col span={8} xs={24} sm={8}>{statTile("Saldo Final Calculado", dineroDisabledMask(saldoFinalCalculado))}</Col>
                  <Col span={8} xs={24} sm={8}>{statTile("Saldo Final", dineroDisabledMask(this.state.saldoFinal))}</Col>
                  <Col span={8} xs={24} sm={8}>
                    {statTile(
                      "Diferencia",
                      dineroDisabledMask(diferencia),
                      conciliadoOk
                        ? { color: "#52c41a", bg: "rgba(82,196,26,0.10)", border: "#52c41a" }
                        : { color: "#ff4d4f", bg: "rgba(255,77,79,0.10)", border: "#ff4d4f" }
                    )}
                  </Col>
                </Row>
                <Divider style={{ margin: "20px 0 10px" }} />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  {mostrarBotonAjuste && (
                    <ButtonItem blanco onClick={this.abrirModalAjuste.bind(this)}>
                      Crear Póliza de Ajuste ({dineroDisabledMask(Math.abs(diferencia))}{sufijoMonedaAjuste})
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    cyan
                    icon={<SaveOutlined />}
                    onClick={this.onFinish.bind(this)}
                    disabled={!conciliadoOk}
                  >
                    Guardar
                  </ButtonItem>
                </div>
              </DynamicCardForm>
            </Row>

            <div ref={this.inicioRef} style={{ marginTop: 36, scrollMarginTop: 80 }}>
              <TabbedDynamicTable
                isMobile={isMobile}
                onTabChange={() => this.medirSeccionFija()}
                key={this.state.tabInicialPdf ? "tabs-pdf" : "tabs-mov"}
                defaultActiveKey={this.state.tabInicialPdf ? "cargarPdf" : "movimientos"}
                tabs={[
                  {
                    key: "movimientos",
                    label: "Movimientos",
                    customContent:
                      this.state.cargosAbonos.length > 0 ? (
                        <div
                          className="tabla-insumos-venta"
                          style={{ overflowY: "auto", maxHeight: "50vh", overflowX: "auto" }}
                        >
                          <table className="table table-12px" style={{ minWidth: isMobile ? "900px" : "100%", width: "100%", backgroundColor: "white" }}>
                            <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
                              <tr>
                                <th className="th-border" style={{ width: "14%" }}>Fecha</th>
                                <th className="th-border" style={{ width: "30%" }}>Concepto</th>
                                <th className="th-border" style={{ width: "17%", textAlign: "center" }}>Deposito (Cargo)</th>
                                <th className="th-border" style={{ width: "17%", textAlign: "center" }}>Pago (Abono)</th>
                                <th className="th-border" style={{ width: "10%", textAlign: "center" }}>
                                  {(() => {
                                    const total = this.state.cargosAbonos.length;
                                    const marcados = this.state.cargosAbonos.filter((ca) => ca.conciliado).length;
                                    const mixto = marcados > 0 && marcados < total;
                                    // El check nunca cambia nada directo: siempre abre la confirmación.
                                    // Con conciliados y pendientes mezclados se elige la acción en el modal.
                                    const accion = mixto ? "elegir" : marcados === total ? "quitar" : "conciliar";
                                    return (
                                      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                        Conciliado
                                        <Tooltip
                                          title={
                                            mixto
                                              ? "Conciliar o quitar todos"
                                              : marcados === total
                                                ? "Quitar todas las conciliaciones"
                                                : "Conciliar todos"
                                          }
                                        >
                                          <Checkbox
                                            checked={total > 0 && marcados === total}
                                            indeterminate={mixto}
                                            disabled={total === 0 || this.state.aplicandoMasivo}
                                            onChange={() => this.setState({ modalMasivo: accion })}
                                          />
                                        </Tooltip>
                                      </span>
                                    );
                                  })()}
                                </th>
                                <th className="th-border" style={{ width: "12%", textAlign: "center" }}>Ver</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.cargosAbonos.map((valueCA, index) => (
                                <tr
                                  key={valueCA._id || index.toString()}
                                  className="fila-insumo"
                                >
                                  <td className="td-border-center">
                                    <p style={{ marginBottom: 0 }}>
                                      {moment(this.state.cargosAbonos[index].fechaRegistro).locale("es").format("ll")}
                                    </p>
                                  </td>
                                  <td className="td-border">
                                    <p style={{ marginBottom: 0 }}>
                                      {this.state.cargosAbonos[index].concepto}
                                    </p>
                                  </td>
                                  <td className="td-border-right">
                                    <p style={{ marginBottom: 0, color: "#53c41ad2", textAlign: "center", fontWeight: this.state.cargosAbonos[index].cargo ? 600 : 400 }}>
                                      {this.state.cargosAbonos[index].cargo
                                        ? dineroDisabledMask(this.state.cargosAbonos[index].cargo)
                                        : ""}
                                    </p>
                                  </td>
                                  <td className="td-border-right">
                                    <p style={{ marginBottom: 0, color: "#ff6a0dd2", textAlign: "center", fontWeight: this.state.cargosAbonos[index].abono ? 600 : 400 }}>
                                      {this.state.cargosAbonos[index].abono
                                        ? dineroDisabledMask(this.state.cargosAbonos[index].abono)
                                        : ""}
                                    </p>
                                  </td>
                                  <td className="td-border-center">
                                    <Checkbox
                                      checked={this.state.cargosAbonos[index].conciliado}
                                      onChange={(e) => this.onChangeConciliacion(e.target.checked, index)}
                                    />
                                  </td>
                                  <td className="td-border-center">
                                    <BotonesOrigenCargoAbono
                                      ventaId={valueCA.ventaId}
                                      polizaId={valueCA.polizaId}
                                      facturaId={valueCA.facturaId}
                                      history={this.props.history}
                                      onVerPoliza={this.abrirPdfPoliza}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <Empty description="No hay movimientos" style={{ padding: "32px 0" }} />
                      ),
                  },
                  {
                    key: "cargarPdf",
                    label: "Cargar PDF",
                    customContent: (
                      <div style={{ padding: 20 }}>
                        {this.state.pdfResultado ? (
                          this.renderResultadoPdf(controlesCargaPdf)
                        ) : (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                            <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                              Carga el PDF del estado de cuenta de tu banco para comparar sus movimientos con los registrados en el sistema.
                            </span>
                            <div style={{ marginLeft: "auto" }}>{controlesCargaPdf}</div>
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
        <ModalItem
          title="Crear Póliza de Ajuste"
          visible={this.state.modalAjuste}
          onCancel={this.cerrarModalAjuste.bind(this)}
          onOk={this.confirmarAjuste.bind(this)}
          spinning={this.state.guardandoAjuste}
          okText="Confirmar"
          footer
          width={500}
          paddingTop
        >
          <p style={{ marginBottom: 10 }}>
            Se creará una póliza de ajuste por <b>{dineroDisabledMask(Math.abs(diferencia))}{sufijoMonedaAjuste}</b> y el movimiento quedará conciliado automáticamente.
          </p>
          <Form
            ref={this.formRefAjuste}
            name="ajusteConciliacion"
            layout
            onValuesChange={(cambios) => {
              if ("tipoDeCambio" in cambios) this.setState({ tcAjuste: cambios.tipoDeCambio });
            }}
          >
            <FormItem label="Fecha" name="fechaPoliza" required margin>
              <DatePickerItem placeholder="Fecha" allowClear={false} />
            </FormItem>
            <FormItem label="Concepto" name="concepto" required margin pattern>
              <InputItem placeholder="Concepto" />
            </FormItem>
            <FormItem label="Proyecto" name="proyectoId" required margin>
              <SelectItem placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
            {!this.esMXN(this.state.monedaBanco) && (
              <FormItem
                label={`Tipo de Cambio (${this.state.monedaBanco.abreviacion})`}
                name="tipoDeCambio"
                required
                margin
                number
              >
                <InputNumberItem placeholder="Tipo de Cambio de la fecha de la póliza" />
              </FormItem>
            )}
            {/* Equivalencia en pesos de lo que se registrará en la póliza */}
            {!this.esMXN(this.state.monedaBanco) && Number(this.state.tcAjuste) > 0 && (() => {
              const tc = Number(this.state.tcAjuste);
              const ajusteMXN = round2Decimals(Math.abs(diferencia) * tc);
              const tolerancia = this.toleranciaConciliacion();
              const excede = ajusteMXN > tolerancia;
              return (
                <div
                  style={{
                    display: "table",
                    margin: "0px auto 10px",
                    position: "relative",
                    left: 40,
                    padding: "5px 8px",
                    borderRadius: 4,
                    fontSize: 11,
                    lineHeight: 1.4,
                    background: excede ? "rgba(255,77,79,0.08)" : "#fafafa",
                    color: "#595959",
                  }}
                >
                  En la póliza: {dineroDisabledMask(Math.abs(diferencia))}{sufijoMonedaAjuste} × {tc} ={" "}
                  <b>{dineroDisabledMask(ajusteMXN)} MXN</b>
                  {excede && (
                    <div style={{ color: "#d4380d", fontWeight: 600 }}>
                      Rebasa el Ajuste Máx. Conciliación ({dineroDisabledMask(tolerancia)} MXN)
                    </div>
                  )}
                </div>
              );
            })()}
            <FormItem label="Cuenta de Ajuste" required margin>
              <Input.Group compact>
                <FormItem name="cuentaAjusteId" noStyle required>
                  <SelectItem placeholder="Cuenta de Ajuste" width="85%">
                    {this.state.objetoCuentaContable}
                  </SelectItem>
                </FormItem>
                <ButtonItem
                  blanco
                  icon={<PlusOutlined />}
                  style={{ width: "15%" }}
                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                />
              </Input.Group>
            </FormItem>
          </Form>
        </ModalItem>
        {this.renderModalEmpate()}
        {this.renderModalCentavos()}
        {this.renderModalPosterior()}
        {this.renderModalMasivo()}
        {this.renderModalHistorialPdf()}
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <ModalPdfPoliza
          visible={this.state.modalPdfPoliza}
          polizaId={this.state.polizaIdPdf}
          onCancel={this.cerrarPdfPoliza}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Conciliacion);
